// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/NeueFrutigerWorldW02-Regular.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  font-size: small;
}
html#root,
body#root,
#root#root {
  overflow: hidden;
}
body {
  font-family: 'NeueFrutigerWorldW02-Regular', sans-serif !important;
  overflow: hidden;
}
body * {
  font-family: 'NeueFrutigerWorldW02-Regular', sans-serif !important;
}
* {
  box-sizing: border-box;
}
@font-face {
  font-family: 'NeueFrutigerWorldW02-Regular';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.customToolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: min-content !important;
}
.columnsPanelTrigger {
  min-height: min-content !important;
  min-width: min-content !important;
}
.filterPanelTrigger {
  min-height: min-content !important;
  min-width: min-content !important;
}
.category {
  height: 80vh;
  display: flex;
  flex-direction: column;
  padding: 2px;
  overflow-y: auto;
}
.category .multi-numeric-icon {
  color: #ffa300;
}
.category .header-section {
  margin-left: 7px;
  width: 99%;
  box-sizing: border-box;
  margin-bottom: 2px;
}
.category .header-section .section-view {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.category .header-section .section-view .edit-view button {
  text-transform: capitalize;
}
.category .header-section .category-header-section {
  display: flex;
  flex-direction: row;
  overflow: hidden;
  width: 100%;
  background: #f2f4f7;
  border-radius: 1px 1px 0px 0px;
  border: 1px solid #dde1e9;
  height: 35px;
  max-height: 35px;
  font-size: 12px !important;
  align-items: center;
}
.category .header-section .category-header-section .breacrum-header-section {
  width: 50%;
  display: flex;
  align-items: center;
}
.category .header-section .category-header-section .breacrum-header-section .css-1v5z4dq-MuiPaper-root-MuiCard-root {
  border: 0px;
}
.category .header-section .category-header-section .breacrum-header-section button {
  padding-top: 0px;
  padding-bottom: 0px;
  width: 100px;
  margin-right: 5px;
  margin-left: 0px;
  height: 33px;
  border-radius: 2px;
  text-transform: capitalize;
}
.category .header-section .category-header-section .breacrum-header-section .MuiPaper-root.MuiCard-root {
  border: 0px;
}
.category .header-section .category-header-section .breacrum-header-section nav {
  white-space: nowrap;
}
.category .categories-container {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  margin-left: 7px;
  width: 99%;
  flex: 1;
  min-height: 369px;
}
.category .categories-container .categories-panel {
  width: 560px;
  display: flex;
  flex-direction: column;
}
.category .categories-container .categories-panel h3 {
  margin-bottom: 8px;
}
.category .categories-container .categories-panel .categories-list {
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  max-height: calc(70vh - 150px);
}
.category .categories-container .droppable-zones {
  display: flex;
  gap: 20px;
  flex: 1;
}
.category .categories-container .droppable-zones > div {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.category .breadcrumb-card-section nav {
  display: flex;
  align-items: center;
  width: 100%;
}
.category .breadcrumb-card-section nav a {
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: color 0.2s ease;
  font-size: 14px;
  padding: 4px 6px;
  border-radius: 4px;
  background-color: #f2f4f7;
}
.category .breadcrumb-card-section nav a.active {
  color: black;
  font-weight: 500;
}
.category .breadcrumb-card-section nav a.not-active {
  color: #666;
}
.category .breadcrumb-card-section nav a.not-active:hover {
  color: #333;
  background-color: rgba(0, 0, 0, 0.04);
}
.category .breadcrumb-card-section nav .MuiSvgIcon-root {
  color: #999;
  margin: 0 8px;
}
.category .category-content {
  display: flex;
  flex: 1;
  height: calc(100% - 100px);
  position: relative;
}
.category .left-pane,
.category .middle-pane,
.category .right-pane {
  position: relative;
}
.category .left-pane {
  --pane-width: 30%;
  width: var(--pane-width);
  min-width: 200px;
  height: 100%;
  border: 1px solid #eee;
  border-radius: 4px;
  margin-left: 8px;
}
.category .middle-pane {
  --pane-width: 35%;
  width: var(--pane-width);
  min-width: 200px;
  height: 96%;
}
.category .right-pane {
  --pane-width: 35%;
  width: var(--pane-width);
  min-width: 200px;
  height: 96%;
}
.category .resize-hor {
  resize: horizontal;
}
.category .disabled-view {
  opacity: 0.6;
  pointer-events: none;
}
.category .assigned-section-header,
.category .unassingned-section-header {
  border-bottom: 2px solid #eee;
  padding-left: 4%;
  font-weight: bold;
}
.category-item {
  position: relative;
}
.category-item.over:not(.invalid) {
  border: 2px solid #1474a4;
}
.category-item.invalid {
  border: 2px solid #ef4444;
  outline: none;
}
.category-item.hover:not(.invalid):not(.over) > div:first-child {
  outline: 2px dashed #1474a4;
}
.category-item .category-row {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}
.category-item .category-content {
  width: 100%;
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.category-item .category-content.selected {
  background: transparent;
}
.category-item .category-content.selected .feature-name,
.category-item .category-content.selected .action-button {
  color: #1474a4;
  font-weight: 500;
}
.category-item .category-content.selected .drag-handle .feature-icon .category-icon {
  color: #1474a4 !important;
}
.category-item .category-content.selected .drag-handle .feature-icon .category-icon.multi-numeric-icon {
  color: #ffa300 !important;
}
.category-item .category-content.parent-selected .feature-name {
  color: #1474a4;
  font-weight: 500;
}
.category-item .category-content.parent-selected .drag-handle .feature-icon .category-icon {
  color: #1474a4 !important;
}
.category-item .category-content.parent-selected .drag-handle .feature-icon .category-icon.multi-numeric-icon {
  color: #ffa300 !important;
}
.category-item .category-title {
  display: flex;
  align-items: center;
  flex: 1;
}
.category-item .drag-handle {
  display: flex;
  align-items: center;
  flex: 1;
}
.category-item .feature-name {
  margin-left: 6px;
}
.category-item .category-actions-wrapper {
  display: flex;
  align-items: center;
  margin-left: 8px;
}
.category-item .subcategories {
  margin-left: 20px;
}
.droppable-zone {
  flex: 1;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  height: 98%;
}
.droppable-zone h3 {
  margin-bottom: 8px;
}
.droppable-zone h3.highlighted {
  color: #1474a4;
}
.droppable-zone .drop-area {
  padding: 15px;
  background: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  z-index: 1;
}
.droppable-zone .drop-area .items-container {
  flex: 1;
  overflow-y: auto;
}
.droppable-zone .drop-area.over:not(.invalid),
.droppable-zone .drop-area[data-highlight='true']:not([data-invalid='true']) {
  border: 2px solid #1474a4 !important;
  border-style: solid !important;
  background: transparent;
  z-index: 2;
  box-shadow: 0 0 0 1px rgba(20, 116, 164, 0.3);
}
.droppable-zone .drop-area.invalid,
.droppable-zone .drop-area[data-invalid='true'] {
  border: 2px solid #ef4444 !important;
  border-style: solid !important;
  background: transparent;
  z-index: 3;
  box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.3);
}
.droppable-zone .drop-area .empty-message {
  color: #666;
  font-style: italic;
}
.draggable-sortable-item.dragging {
  cursor: grabbing;
  opacity: 0.4;
  background-color: #f0f6ff !important;
  border: 1px dashed #ccc;
  box-shadow: none;
  z-index: 1000 !important;
  pointer-events: none;
}
.draggable-sortable-item.sortable {
  border-radius: 4px;
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.draggable-sortable-item.sortable .item-content {
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  letter-spacing: 0.00938em;
}
.draggable-sortable-item.sortable .item-content .item-description {
  margin-right: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.draggable-sortable-item.sortable .item-content .item-code {
  flex-shrink: 0;
  white-space: nowrap;
  color: #666;
}
.draggable-sortable-item.sortable .item-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.draggable-sortable-item.sortable .item-actions .drag-handle {
  color: #666;
  font-size: 14px;
}
.draggable-sortable-item.draggable {
  border-radius: 4px;
  cursor: grab;
  display: flex;
  align-items: center;
}
.draggable-sortable-item.draggable .item-content {
  margin-left: 8px;
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  letter-spacing: 0.00938em;
}
.draggable-sortable-item.draggable .item-content .item-description {
  margin-right: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.draggable-sortable-item.draggable .item-content .item-code {
  flex-shrink: 0;
  white-space: nowrap;
  color: #666;
}
.draggable-sortable-item.disabled {
  opacity: 0.6;
  cursor: default;
  pointer-events: none;
  color: #888;
}
.draggable-sortable-item.disabled.sortable {
  background: #f7f9ff;
}
.draggable-sortable-item.disabled.draggable {
  background: #f5f5f5;
}
.common-dialog-style .MuiPaper-root .MuiDialogTitle-root {
  background: #1474a4;
  color: #fff;
  padding: 7px;
  padding-left: 23px;
  cursor: move;
}
.common-dialog-style .MuiPaper-root .MuiBox-root {
  width: 100%;
}
.add-category-dialog .MuiPaper-root {
  width: 80%;
}
.drag-preview {
  padding: 2px 2px;
  border-radius: 4px;
  background: #1474a4;
  color: #ffffff;
  font-weight: 500;
  font-size: 12px;
  pointer-events: none;
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  gap: 5px;
}
.drag-preview .item-code {
  opacity: 0.8;
  font-size: 12px;
}
[data-dnd-overlay] {
  z-index: 9999 !important;
}
.drag-overlay-content {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
}
.drag-overlay-content .item-name {
  font-weight: 500;
}
.drag-overlay-content .item-code {
  color: #666;
}
.auto-complete-searchbar {
  margin-top: 16px;
  display: flex;
}
.auto-complete-search-input {
  flex-basis: 90%;
}
.auto-complete-search-input .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
  border-radius: 4px 0px 0px 4px !important;
}
.auto-complete-search-button {
  background: white;
  border-radius: 0px 4px 4px 0px !important;
  border: solid 2px #e2e2e2 !important;
  border-left: none !important;
}
.auto-complete-search-icon {
  font-size: 25px !important;
  color: #1474a4 !important;
}
.css-xnywni-MuiFormLabel-root-MuiInputLabel-root {
  top: 20px !important;
  position: relative !important;
}
.css-196bwzp-MuiPaper-root-MuiCard-root {
  background-color: #f2f4f7 !important;
}
.css-1umw9bq-MuiSvgIcon-root {
  width: 16px !important;
  height: 0.9em !important;
}
.header-large-icon {
  font-size: 1.7rem !important;
  line-height: 1;
}
.icon-with-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 24px;
}
.edit-view {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}
.icon-helper-text {
  font-size: 0.95rem;
  color: #1474a4;
  font-weight: 500;
  letter-spacing: 0.01em;
}
.css-nykz7-MuiTreeItem-content {
  padding: 4px 8px 0px 0px !important;
  gap: 0px !important;
}
.css-nykz7-MuiTreeItem-content.Mui-selected {
  background-color: revert !important;
}
.category-wrapper {
  padding-left: 0;
}
.category-wrapper[data-section-depth] {
  padding-left: calc(var(--category-depth, 0) * 20px);
}
.css-fojsl4-MuiTreeItem-content {
  gap: 0px !important;
}
.small-badge .MuiBadge-badge {
  font-size: 0.65rem;
  height: 16px;
  min-width: 16px;
  padding: 0 4px;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #5a9dbf;
}
::-webkit-scrollbar-thumb:hover {
  background: #5a9dbf;
}
.footer {
  border-top: 0.1rem solid rgba(0, 0, 0, 0.12);
  color: black;
  margin-right: 1px;
  display: flex;
  flex-direction: row;
}
.footer.root {
  display: flex;
  width: 100% !important;
  font-size: 12px;
}
.footer .env {
  margin-right: 1px;
  padding-right: 1px;
}
.footer .termsAndCondition {
  display: flex;
  flex-direction: row;
  margin-right: 1px;
}
.footer.bg-gray {
  background-color: #eeeeee;
}
.footer.bg-green {
  background-color: #93c47d;
}
.footer.bg-orange {
  background-color: #f7d368;
}
.footer.bg-yellow {
  background-color: #f3f66b;
}
.termsAndCondition-dialog .paperClass {
  width: 45%;
  height: 60vh;
}
.d-flex {
  display: flex;
}
.d-inline-flex {
  display: inline-flex;
}
.d-block {
  display: block;
}
.d-inline-block {
  display: inline-block;
}
.d-inline {
  display: inline;
}
.flex-row {
  flex-direction: row;
}
.flex-column {
  flex-direction: column;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.squareSize {
  width: 100%;
  height: 100%;
}
.w-0 {
  width: 0%;
}
.w-25 {
  width: 25%;
}
.w-50 {
  width: 50%;
}
.w-100 {
  width: 100% !important;
}
.w-auto {
  width: auto;
}
.w-25ch {
  width: '25ch';
}
.w-10 {
  width: 10%;
}
.w-20 {
  width: 20%;
}
.w-40 {
  width: 40%;
}
.w-45 {
  width: 45%;
}
.w-90 {
  width: 90%;
}
.mw-0 {
  max-width: 0%;
}
.mw-25 {
  max-width: 25%;
}
.mw-50 {
  max-width: 50%;
}
.mw-100 {
  max-width: 100%;
}
.mw-10 {
  max-width: 10%;
}
.h-0 {
  height: 0%;
}
.h-25 {
  height: 25%;
}
.h-50 {
  height: 50%;
}
.h-100 {
  height: 100% !important;
}
.h-90vh {
  height: 90vh !important;
}
.h-auto {
  height: auto;
}
.h-inherit {
  height: inherit;
}
.m-0 {
  margin: 0;
}
.mt-0 {
  margin-top: 0;
}
.mt-1em {
  margin-top: 1em !important;
}
.mr-0 {
  margin-right: 0;
}
.mr-5px {
  margin-right: 5px !important;
}
.mb-0 {
  margin-bottom: 0;
}
.mb-05em {
  margin-bottom: 0.5em !important;
}
.ml-0 {
  margin-left: 0;
}
.ml-1 {
  margin-left: 1% !important;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.p-0 {
  padding: 0px !important;
}
.p-1 {
  padding: 1px !important;
}
.p-3px {
  padding: 3px !important;
}
.p-5px {
  padding: 5px;
}
.p-10px {
  padding: 10px !important;
}
.p-20px {
  padding: 20px;
}
.p-15px {
  padding: 15px;
}
.p-1rem {
  padding: 1rem;
}
.pt-0 {
  padding-top: 0 !important;
}
.pt-1 {
  padding-top: 1em !important;
}
.pr-1 {
  padding-right: 1em !important;
}
.pl-0 {
  padding-left: 0;
}
.pr-0 {
  padding-right: 0;
}
.pb-0 {
  padding-bottom: 0 !important;
}
.pb-1 {
  padding-bottom: 1em !important;
}
.float-right {
  float: right;
}
.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.px-0 {
  padding-right: 0;
  padding-left: 0;
}
.overflow-auto {
  overflow: auto;
}
.overflowX-auto {
  overflow-x: auto;
}
.overflowY-auto {
  overflow-y: auto;
}
.text-left {
  text-align: left !important;
}
.text-right {
  text-align: right !important;
}
.text-center {
  text-align: center;
}
.text-capitalize {
  text-transform: capitalize !important;
}
.text-bold {
  font-weight: bold;
}
.ws-nowrap {
  white-space: nowrap !important;
}
.vertical-middle {
  vertical-align: middle;
}
.align-top {
  align-items: flex-start;
}
.align-center {
  align-items: center;
}
.alignself-center {
  align-self: center;
}
.alignself-start {
  align-self: self-start;
}
.justify-left {
  justify-content: left !important;
}
.justify-center {
  justify-content: center;
}
.justify-right {
  justify-content: right;
}
.justify-end {
  justify-content: flex-end;
}
.justify-spacebetween {
  justify-content: space-between;
}
.justify-start {
  justify-content: flex-start;
}
.cursor-move {
  cursor: move;
}
.warning {
  color: #f7d368 !important;
}
.bottomUnset {
  border-bottom: unset;
}
.rowFlex {
  display: flex;
  flex-direction: row;
}
.colFlex {
  display: flex;
  flex-direction: column;
}
.flex-start {
  justify-content: flex-start;
  align-items: flex-start;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-default {
  cursor: default !important;
}
.position-absolute {
  position: absolute;
}
.overflow-hidden {
  overflow: hidden;
}
.textWidth50 {
  width: 50%;
  display: inline-block;
}
.overflowY-hidden {
  overflow-y: hidden;
}
.overflow-ellipsis {
  text-overflow: ellipsis;
}
.overflowWrap-anywhere {
  overflow-wrap: anywhere;
}
.zindex-100 {
  z-index: 100;
}
.zindex-2000 {
  z-index: 2000;
}
.border-radius-0 {
  border-radius: 0 !important;
}
.bg-philips-blue {
  background-color: #1474a4;
}
.bg-lightgray {
  background-color: lightgray;
}
.b-0 {
  border: 0;
}
.philipsBlue {
  color: #1474a4 !important;
}
.PhilipsRed {
  color: red;
}
.zoom80 {
  zoom: 80%;
}
.appRouter.root {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  padding: 0;
}
.appRouter .secondaryHeader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 38px;
}
.appRouter .secondaryHeader .headername {
  padding: 10px !important;
  display: flex;
  color: #1474a4;
  font-weight: bold;
  font-size: 14px;
}
.appRouter .secondaryHeaderTabs {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
}
.appRouter .appRouterContent {
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  overflow: hidden;
  width: -webkit-fill-available;
}
.appRouter .divider {
  width: 100%;
}
.termsAndConditionStyle {
  display: flex;
  flex-direction: row;
  margin-right: 1px;
}
.termsAndConditionStyle .title {
  cursor: pointer;
  text-decoration: underline;
  color: blue;
}
.headerStyle.root {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
.headerStyle .toolbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 10px;
  min-height: 3rem;
  padding-top: 0.3rem !important;
  padding-bottom: 0.3rem !important;
}
.headerStyle .toolbarSection {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.headerStyle .tooltip {
  margin: 2;
}
.headerStyle .button-icon {
  cursor: pointer;
  color: #ffffff;
}
.userPanelIconButton {
  cursor: pointer;
  color: white !important;
  padding: 5px !important;
}
.userPanelIconButton .userProfileIcon {
  height: 2rem;
  width: 2rem;
}
.popperStyle.arrow {
  width: 3em;
  height: 3em;
}
.popperStyle::before {
  content: '';
  margin: auto;
  display: block;
  width: 0%;
  border-style: solid;
  border-width: 0px 1em 1em;
  border-color: transparent transparent #ffffff;
  margin-top: -0.4rem;
}
.middle-container {
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100% !important;
  padding: 0.5em 1em;
}
.middle-container .mainHeader {
  margin-top: 0em;
  margin-bottom: 0.2em;
}
.common-dialog-paper {
  width: 550px !important;
  min-width: 550px !important;
}
.common-dialog-style .header {
  background-color: #1474a4;
  font-size: 1.2rem;
  padding: 0.5rem;
  border-bottom: 0.1rem solid rgba(0, 0, 0, 0.12);
  color: white;
  text-align: left !important;
}
.common-dialog-style .paper {
  height: 60vh;
}
.common-dialog-style .dialogContent {
  padding-top: 4vh !important;
}
.common-dialog-style .closeIcon {
  position: absolute;
  right: 0px;
  top: 0px;
  color: white;
}
.landing-Page-body {
  display: block;
  width: 100%;
  height: 100%;
}
.header4 {
  font-size: large;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
}
.catalog-Container {
  width: 376px;
  height: 100px;
  padding: 5px;
}
.catalog-cardLayout {
  display: flex;
  padding: 10px !important;
}
.catalog-image {
  height: 80px;
  width: 80px;
  margin-left: 5px;
  margin-top: 5px;
}
.catalog-info {
  flex-basis: 90%;
  padding: 5px;
}
.catalog-productDescription {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 34ch;
}
.noData-label {
  width: 50%;
  margin-left: 45%;
  padding-top: 15%;
}
.catalog-icon {
  display: flex;
  flex-basis: 10%;
  padding: 5px;
  cursor: pointer;
}
.catalog-create {
  background-color: #1474a4 !important;
}
.productCatalogCardHeader {
  color: #1474a4;
  font-weight: bold;
}
.list-Section {
  display: block;
  height: calc(90% - 8.6rem);
  padding: 0px 10px 10px 10px;
  overflow-y: auto;
  overflow-x: hidden;
}
.list-Section ul > div {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.list-Section-Tab {
  display: block;
  width: 100%;
  height: 100%;
}
.list-Items {
  padding-top: 0px !important;
}
.list-Section::-webkit-scrollbar {
  height: 10px;
}
.list-ItemsContainer {
  margin-left: 0px !important;
  padding: 5px;
}
.recordsPerPage {
  height: 30px;
  margin-right: 15px;
}
.recordsPerPage > div {
  padding: 8.5px !important;
}
.refresh-button {
  min-height: min-content !important;
  min-width: min-content !important;
  padding: 6px 8px;
  position: relative !important;
}
.procos-export-button {
  margin-left: 30px !important;
  text-transform: none !important;
}
.pcs-export-button {
  margin-left: 40px !important;
  text-transform: none !important;
}
.refresh-button > span {
  padding-right: 2px;
  margin: 0px !important;
}
.export-button > span {
  margin: 4px !important;
}
.recordsChange-conatiner {
  display: flex;
  flex-direction: row-reverse;
  margin-right: 10px;
  align-items: center;
}
.recordsChange-conatiner .form-control {
  width: 5.5rem;
  margin-left: 10px;
}
.Records {
  display: flex;
  justify-content: flex-end;
}
.home-icon {
  color: #1474a4 !important;
  width: 100%;
  padding: 3px !important;
  margin: 0px !important;
}
.action-icon {
  color: #1474a4 !important;
  margin: 0px !important;
  padding: 2px !important;
}
.action-icon-disabled {
  color: #eeeeee !important;
  margin: 0px !important;
  padding: 3px !important;
}
.form-text {
  color: red !important;
}
.breadCrumb.root {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 10px;
}
.breadCrumb .item {
  color: #1474a4 !important;
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  font-size: 1rem;
  font-weight: bold;
}
.breadCrumb .activeItem {
  font-weight: bold;
}
.search-bar.MuiAutocomplete-root {
  width: 20em !important;
  position: relative;
  bottom: 3px;
  right: 20px;
  padding-top: 0.3rem;
}
.search-bar.MuiAutocomplete-root .search-inner-text > div {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  margin-left: 0.7vw;
}
.search-bar.MuiAutocomplete-root .search-inner-text > div > div > button {
  visibility: visible !important;
}
.search-bar.MuiAutocomplete-root .search-inner-text > div > div > svg {
  position: absolute !important;
  top: 1.1vh !important;
  left: 0.2vw !important;
}
.unsupported-browser {
  display: inline-block;
  text-align: center;
  width: 45%;
  height: 90%;
  margin-left: auto;
  margin-right: auto;
}
.unsupported-browser .message {
  text-align: left;
  padding-top: 5px !important;
}
.unsupported-browser .unsupported-browser-image {
  height: 50;
  width: 40;
}
.unsupported-browser .versionSupported {
  z-index: 150000 !important;
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.unsupported-browser .versionSupported .browserBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 2%;
  justify-content: space-between;
}
.unsupported-browser .versionSupported .browserBox img {
  height: 35px;
  width: 35px;
}
.unsupported-browser .versionSupported .browserBox .browserDetails {
  display: flex;
  flex-direction: column;
}
.activeIcon {
  color: #eeeeee !important;
  background-color: #1474a4 !important;
}
.languageContainer {
  font-size: 1rem !important;
  padding: 0px !important;
  vertical-align: middle !important;
  align-items: center !important;
  border-radius: 0 !important;
  width: max-content;
}
.data-table {
  height: calc(90% - 8.6rem);
  padding-bottom: 10px;
  width: 60%;
}
.features-table {
  height: calc(90% - 8.6rem);
  width: 100%;
}
.features-table .recordPicker {
  position: relative;
  bottom: 3px;
  padding-top: 0.3rem;
}
.alert-dialog {
  display: inline-block;
  width: 45%;
  height: 90%;
  margin-left: auto;
  margin-right: auto;
  min-width: 30%;
}
.alert-dialog .MuiDialog-container .MuiPaper-root {
  min-width: 40%;
}
.autocomplete-div {
  margin-top: 0.3%;
  flex-basis: 35%;
}
.tab-Panel {
  height: 20px !important;
  min-height: 20px !important;
}
.loading-message {
  display: block;
  text-align: center;
  background: white;
  padding: 50px;
  box-shadow: 1px 1px 2px 1px grey;
  border-radius: 3px;
  width: 30%;
  min-width: 30%;
}
.manage-tab-pagination {
  align-items: center;
  margin-top: 1rem;
  height: 8rem;
}
.procos-pagination {
  width: 60%;
  align-items: center;
}
.procos-features-pagination {
  width: 100%;
  align-items: center;
  padding-top: 1%;
}
.common-btn {
  height: 2.5rem;
  white-space: nowrap;
}
.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.tab-drawer-tabs {
  text-transform: capitalize !important;
  align-items: center;
  justify-content: left !important;
  text-align: left !important;
  min-height: 30px;
  padding: 7px;
  color: rgba(0, 0, 0, 0.87) !important;
}
.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected.tab-drawer-tabs {
  color: #1474a4 !important;
  background: #c7e0f4 !important;
  font-weight: 800 !important;
}
.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.pdm-tabs {
  text-transform: capitalize !important;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  padding: 7px;
  color: rgba(0, 0, 0, 0.87) !important;
}
.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected.pdm-tabs {
  color: #1474a4 !important;
  font-weight: 800 !important;
}
.navigateTabLabel {
  writing-mode: tb-rl;
  height: inherit;
  cursor: pointer;
  font-size: 1.25rem;
  white-space: nowrap;
}
.pinIcon {
  font-size: 1.4rem !important;
}
.tabDrawerMini {
  width: 4.5rem;
  height: auto;
  text-align: center;
  background: #eeeeee;
  z-index: 100;
}
.drawerOpen {
  width: 200px;
}
.drawer-tab {
  min-height: 500px !important;
}
.pdm-tab {
  height: 32px !important;
  min-height: 32px !important;
}
.checkbox-highlight {
  box-shadow: inset 0px 0px 1px 1px orange;
}
.procos-tab-panel {
  min-height: 20px !important;
}
.tabs-padding {
  padding: 7px 15px 7px 15px;
}
.tab-icon {
  margin-right: 5px;
}
.failed-rule {
  max-height: 100px;
  padding: 5px;
}
.autocomplete {
  padding: 3px !important;
}
.contents {
  display: flex;
  justify-content: space-between;
  height: 100%;
}
.leftBar {
  border-right: 1px solid #e0e0e0;
  width: 20%;
  height: 100% !important;
  overflow: hidden;
}
.leftBar .MuiAutocomplete-inputRoot {
  border-radius: 0;
}
.leftBar .defaultExpandIcon {
  color: #0062a1;
}
.leftBar .defaultCollapseIcon {
  color: #0078ce;
}
.leftBar .defaultEndIcon {
  color: #eeeeee;
}
.leftBar .featuresTree {
  height: 80%;
  max-width: 100%;
  overflow-y: auto;
}
.leftBar .treeSearchBar .innerTextField > div {
  padding-top: 0% !important;
  padding-bottom: 0% !important;
}
.leftBar .treeSearchBar .innerTextField > div > div > button {
  visibility: visible !important;
}
.rightBar {
  width: 100% !important;
  height: 95% !important;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  justify-content: space-between;
  padding-right: 1%;
  padding-left: 0.5%;
}
.properties-div {
  height: 80% !important;
}
.properties-div .refresh-button path {
  font-size: 18px !important;
}
.inputFieldset {
  box-sizing: border-box;
  border-radius: 4px;
  border-width: 1.5px;
  border-color: rgba(0, 0, 0, 0.2);
  border-style: solid;
  width: 100%;
  padding-bottom: 4px !important;
  padding-left: 0.8rem !important;
  margin-top: 10px !important;
}
.inputFieldset:hover:not(:focus):not(:focus-within) {
  border-color: rgba(0, 0, 0, 0.87);
}
.inputFieldset:focus-within {
  border-color: #1173a3;
}
.inputFieldset > legend.inputLegend {
  color: rgba(0, 0, 0, 0.6);
  word-break: break-all;
}
.inputFieldset:focus-within > legend.inputLegend {
  color: #1474a4;
}
.inputFieldset:hover:not(:focus):not(:focus-within) > legend.inputLegend {
  color: rgba(0, 0, 0, 0.87);
}
.properties-pane-title {
  padding-bottom: 1px !important;
}
.flow {
  overflow: auto;
  height: 92%;
}
.action-button {
  display: flex;
  height: 8%;
  padding: 1px;
}
.toggle-switch {
  padding-left: 1%;
  padding-top: 0px !important;
}
.switch-field {
  padding: 8px !important;
}
.switch-field .MuiSwitch-track {
  border-radius: 11px;
}
.switch-field .MuiSwitch-track::before,
.switch-field .MuiSwitch-track::after {
  position: absolute;
  top: 40%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
}
.switch-field .MuiSwitch-track::before {
  content: 'Y';
  left: 17px;
  color: white;
}
.switch-field .MuiSwitch-track::after {
  content: 'N';
  right: 8px;
  color: white;
}
.switch-field .MuiSwitch-thumb {
  box-shadow: none;
  width: 16px;
  height: 16px;
  margin: 2px;
}
.warning-icon {
  font-size: 1.8rem !important;
  color: #f7d368;
}
.defaultIcon {
  color: hsl(51, 79%, 25%);
  border: 2px solid hsl(51, 59%, 55%);
  background-color: hsl(51, 89%, 95%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 56px;
}
.defaultIcon.empty {
  border: none;
  background-color: transparent;
}
.MuiDataGrid-columnSeparator--resizable {
  cursor: e-resize !important;
}
.css-15l8jjv .MuiDataGrid-columnSeparator--resizable {
  cursor: e-resize;
  touch-action: none;
}
.status-inactive {
  background: grey;
  color: white;
  text-align: center;
}
.status-active {
  background: forestgreen;
  color: white;
  text-align: center;
}
.inActiveWarningMessage {
  margin-left: 0.5em;
}
.inActiveWarningMessage .warningMessage {
  font-size: 2rem !important;
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  color: #f7d368;
  font-size: 1rem !important;
}
.inActiveWarningMessage .warningSize {
  height: 100% !important;
  width: 2em !important;
  color: #f7d368;
}
.inActiveWarningMessage .warningIcon {
  color: #f7d368;
  font-size: 2rem !important;
}
.navbar {
  font-size: 12px !important;
  line-height: 3 !important;
}
.navbar a {
  color: grey;
  text-decoration: none !important;
}
.navbar a.active {
  color: #1474a4;
  border-bottom: 2px solid #1474a4 !important;
  text-decoration: none !important;
}
.headerLogo {
  cursor: pointer !important;
}
.cellWithValueAsNo {
  background-color: pink !important;
  color: red !important;
}
.active-menu {
  width: 10rem;
}
.fail-effectivity {
  height: 150px;
  overflow-y: auto;
}
.icon-font-size {
  font-size: 2rem !important;
  margin-right: 5px !important;
}
.properties-content {
  height: 100%;
}
.header-action {
  display: flex;
  justify-content: flex-end;
}
.disabled {
  pointer-events: none;
  opacity: 0.5;
}
.enabled {
  pointer-events: auto;
  opacity: 1;
}
.toast-content-default {
  background-color: white;
}
.toast-content-success {
  background-color: #93c47d;
  color: black;
}
.toast-content-warning {
  background-color: #f7d368;
  color: black;
}
.toast-content-error {
  background-color: red;
  color: black;
}
.wi-toast-content-success {
  background-color: #93c47d;
  color: black;
}
.effectivity-toast-content-success {
  margin-top: 90px;
  background-color: #93c47d;
  color: black;
}
.effectivity-toast-content-error {
  margin-top: 90px;
  background-color: red;
  color: black;
}
.absolute-right {
  position: absolute !important;
  right: 0;
}
.appTabs-border {
  border-bottom: solid 1px rgba(0, 0, 0, 0.12);
}
.link {
  cursor: pointer;
  text-decoration: underline !important;
  color: blue !important;
}
.data-table-container {
  /* Add this class to the container */
  display: flex;
  flex-direction: column;
  flex: 1;
  /* Allow container to grow */
  overflow: auto;
  /* Allow scrolling if content overflows */
  width: 100%;
}
.data-table-container .data-table {
  flex-grow: 1;
  /* Allow DataTable to grow */
}
.data-table-container .pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50px;
  /* Ensure pagination is visible */
  padding: 1rem;
  overflow: auto;
}
.data-table-container .pagination-container .MuiPagination-root {
  width: 100%;
}
.manipulation-dialog {
  width: 100%;
  min-height: 50%;
  height: 70%;
  max-height: 70%;
  max-width: 100%;
  margin-top: 10rem;
  z-index: 99 !important;
}
.manipulation-dialog .formActionButtons {
  text-align: right;
}
.tabsAndActionPanel {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.searchIconForColumn {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.h-3-5 {
  height: 3.5%;
}
.headerLogoButton {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}
.pdmHistoryDialogStyle .paper {
  width: 85% !important;
  height: 110vh !important;
  max-width: 100% !important;
}
.pdmHistoryDialogStyle .title {
  display: flex;
  /* keeps first span at start in normal flow */
  align-items: center;
  /* vertical centering if there's height */
  justify-content: start;
  gap: 4px;
  width: 100%;
  position: relative;
}
.pdmHistoryDialogStyle .start {
  /* stays at the start in normal flow */
  width: max-content;
  min-width: max-content;
  text-align: start;
}
.pdmHistoryDialogStyle .center {
  width: max-content;
  text-align: start;
  display: flex;
  justify-content: start;
  text-overflow: clip;
}
.pdmHistoryDialogStyle .close {
  align-items: center;
  justify-content: center;
  margin-left: auto;
  height: 100%;
  width: max-content;
  min-width: max-content;
  color: white;
}
.pdmHistoryDialogStyle .dialogContent {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px !important;
}
.pdmHistoryDialogStyle .dialogContent .MuiDataGrid-root {
  min-height: 90% !important;
}
.pdmHistoryDialogStyle .dialogContent .manage-tab-pagination {
  margin-top: 0 !important;
  justify-content: center;
  align-items: center;
}
.historyFilterPanel {
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: max-content !important;
}
.historyFilterPanel .historyFilterContent {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: row;
  width: max-content !important;
}
.historyFilterPanel .historyFilterContent .historyFilterRow {
  display: flex;
  gap: 16px;
  flex-direction: row;
  align-items: center;
  width: max-content !important;
}
.historyFilterPanel .historyFilterContent .historyFilterRow .historyFilterFormControl {
  min-width: 145px;
}
.color-red {
  color: red !important;
}
.history-button path {
  font-size: 18px !important;
}
.history-button span {
  font-size: 12px !important;
}
.delete-button {
  text-transform: capitalize !important;
  color: red;
}
.autocomplete-value-mismatch .MuiOutlinedInput-notchedOutline {
  border-color: red !important;
}
.autocomplete-value-mismatch .MuiOutlinedInput-input {
  color: red !important;
  -webkit-text-fill-color: red !important;
}
.autocomplete-value-mismatch .Mui-disabled .MuiOutlinedInput-notchedOutline {
  border-color: red !important;
}
.autocomplete-value-mismatch .Mui-disabled .MuiOutlinedInput-input {
  -webkit-text-fill-color: red !important;
}
.autocomplete-value-mismatch .MuiInputLabel-root.Mui-disabled {
  color: red !important;
}
/*# sourceMappingURL=index.css.map */`, "",{"version":3,"sources":["webpack://./index.less","webpack://./style/index.less","webpack://./category.less"],"names":[],"mappings":"AAAA;;;EAGE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;ACCF;ADCE;;;EACE,gBAAA;ACGJ;ADCA;EACE,kEAAA;EACA,gBAAA;ACCF;ADEA;EACE,kEAAA;ACAF;ADGA;EACE,sBAAA;ACDF;ADIA;EACE,2CAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4CAAA;ACFF;AChCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kCAAA;ADkCF;AC/BA;EACE,kCAAA;EACA,iCAAA;ADiCF;AC9BA;EACE,kCAAA;EACA,iCAAA;ADgCF;AC3BA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AD6BF;AClCA;EAQI,cAAA;AD6BJ;ACrCA;EAYI,gBAAA;EACA,UAAA;EACA,sBAAA;EACA,kBAAA;AD4BJ;AC3CA;EAkBM,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AD4BN;ACjDA;EAyBU,0BAAA;AD2BV;ACpDA;EA+BM,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;ADwBN;ACjEA;EA4CQ,UAAA;EACA,aAAA;EACA,mBAAA;ADwBR;ACtEA;EAgDU,WAAA;ADyBV;ACzEA;EAmDU,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;ADyBV;ACnFA;EA8DU,WAAA;ADwBV;ACtFA;EAkEU,mBAAA;ADuBV;ACzFA;EAyEI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,OAAA;EACA,iBAAA;ADmBJ;AClGA;EAkFM,YAAA;EACA,aAAA;EACA,sBAAA;ADmBN;ACvGA;EAuFQ,kBAAA;ADmBR;AC1GA;EA2FQ,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,8BAAA;ADkBR;AClHA;EAqGM,aAAA;EACA,SAAA;EACA,OAAA;ADgBN;ACvHA;EA2GQ,OAAA;EACA,aAAA;EACA,sBAAA;ADeR;AC5HA;EAoHM,aAAA;EACA,mBAAA;EACA,WAAA;ADWN;ACjIA;EAyHQ,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;ADWR;ACTQ;EACE,YAAA;EACA,gBAAA;ADWV;ACRQ;EACE,WAAA;ADUV;ACRU;EACE,WAAA;EACA,qCAAA;ADUZ;ACtJA;EAkJQ,WAAA;EACA,aAAA;ADOR;AC1JA;EAyJI,aAAA;EACA,OAAA;EACA,0BAAA;EACA,kBAAA;ADIJ;AChKA;;;EAkKI,kBAAA;ADGJ;ACrKA;EAsKI,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;ADEJ;AC9KA;EAgLI,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,WAAA;ADCJ;ACpLA;EAuLI,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,WAAA;ADAJ;AC1LA;EA8LI,kBAAA;ADDJ;AC7LA;EAkMI,YAAA;EACA,oBAAA;ADFJ;ACjMA;;EAwMI,6BAAA;EACA,gBAAA;EACA,iBAAA;ADHJ;ACQA;EACE,kBAAA;ADNF;ACOE;EAEE,yBAAA;ADNJ;ACSE;EAEE,yBAAA;EAEA,aAAA;ADTJ;ACYE;EAEI,2BAAA;ADXN;ACLA;EAqBI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;ADbJ;ACXA;EA4BI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;ADdJ;ACeI;EAEE,uBAAA;ADdN;ACYI;;EAOI,cAAA;EACA,gBAAA;ADfR;ACOI;EAaI,yBAAA;ADjBR;ACII;EAkBI,yBAAA;ADnBR;ACwBI;EAEI,cAAA;EACA,gBAAA;ADvBR;ACoBI;EAQI,yBAAA;ADzBR;ACiBI;EAYI,yBAAA;AD1BR;AC3CA;EA2EI,aAAA;EACA,mBAAA;EACA,OAAA;AD7BJ;AChDA;EAgFI,aAAA;EACA,mBAAA;EACA,OAAA;AD7BJ;ACrDA;EAqFI,gBAAA;AD7BJ;ACxDA;EAwFI,aAAA;EACA,mBAAA;EACA,gBAAA;AD7BJ;AC7DA;EA6FI,iBAAA;AD7BJ;ACkCA;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;ADhCF;AC2BA;EAQI,kBAAA;ADhCJ;ACkCI;EACE,cAAA;ADhCN;ACqBA;EAgBI,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;EACA,gBAAA;EACA,UAAA;ADlCJ;ACWA;EA0BM,OAAA;EACA,gBAAA;ADlCN;ACqCI;;EAEE,oCAAA;EACA,8BAAA;EACA,uBAAA;EACA,UAAA;EACA,6CAAA;ADnCN;ACsCI;;EAEE,oCAAA;EACA,8BAAA;EACA,uBAAA;EACA,UAAA;EACA,4CAAA;ADpCN;ACTA;EAiDM,WAAA;EACA,kBAAA;ADrCN;AC4CE;EACE,gBAAA;EACA,YAAA;EACA,oCAAA;EACA,uBAAA;EACA,gBAAA;EACA,wBAAA;EACA,oBAAA;AD1CJ;AC4CE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AD1CJ;ACoCE;EASI,OAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AD1CN;AC0BE;EAmBM,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AD1CR;ACoBE;EA0BM,cAAA;EACA,mBAAA;EACA,WAAA;AD3CR;ACeE;EAiCI,aAAA;EACA,mBAAA;EACA,QAAA;AD7CN;ACUE;EAsCM,WAAA;EACA,eAAA;AD7CR;ACkDE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;ADhDJ;AC4CE;EAMI,gBAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AD/CN;ACiCE;EAiBM,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AD/CR;AC2BE;EAwBM,cAAA;EACA,mBAAA;EACA,WAAA;ADhDR;ACqDE;EACE,YAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;ADnDJ;ACqDI;EACE,mBAAA;ADnDN;ACsDI;EACE,mBAAA;ADpDN;AC0DA;EAGM,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AD1DN;ACmDA;EAWM,WAAA;AD3DN;AC+DA;EAEI,UAAA;AD9DJ;ACkEA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;ADhEF;ACkDA;EAiBI,YAAA;EACA,eAAA;ADhEJ;ACqEA;EACE,wBAAA;ADnEF;ACsEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;ADpEF;ACgEA;EAOI,gBAAA;ADpEJ;AC6DA;EAWI,WAAA;ADrEJ;ACyEA;EACE,gBAAA;EACA,aAAA;ADvEF;AC0EA;EACE,eAAA;ADxEF;ACuEA;EAII,yCAAA;ADxEJ;AC4EA;EACE,iBAAA;EACA,yCAAA;EACA,oCAAA;EACA,4BAAA;AD1EF;AC6EA;EACE,0BAAA;EACA,yBAAA;AD3EF;AC8EA;EACE,oBAAA;EACA,6BAAA;AD5EF;AC+EA;EACE,oCAAA;AD7EF;ACgFA;EACE,sBAAA;EACA,wBAAA;AD9EF;ACkFA;EACE,4BAAA;EACA,cAAA;ADhFF;ACmFA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;ADjFF;ACoFA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;ADlFF;ACqFA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;ADnFF;ACsFA;EACE,mCAAA;EACA,mBAAA;ADpFF;ACuFA;EACE,mCAAA;ADrFF;ACwFA;EACE,eAAA;ADtFF;ACyFA;EACE,mDAAA;ADvFF;AC0FA;EACE,mBAAA;ADxFF;AD3eA;EAEI,kBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AC4eJ;ADveA;EACE,UAAA;EACA,WAAA;ACyeF;ADteA;EACE,mBAAA;ACweF;ADreA;EACE,mBAAA;ACueF;ADpeA;EACE,mBAAA;ACseF;ADneA;EAkBE,4CAAA;EACA,YAAA;EACA,iBAAA;EA8BA,aAAA;EAoBA,mBAAA;ACoaF;ADzeE;EAiDA,aAAA;EAiDA,sBAAA;EA/FE,eAAA;AC2eJ;AD/eA;EAQI,iBAAA;EACA,kBAAA;AC0eJ;ADnfA;EAkDE,aAAA;EAoBA,mBAAA;EAvDE,iBAAA;ACyeJ;AD/dE;EACE,yBAAA;ACieJ;AD9dE;EACE,yBAAA;ACgeJ;AD7dE;EACE,yBAAA;AC+dJ;AD5dE;EACE,yBAAA;AC8dJ;AD1dA;EAEI,UAAA;EACA,YAAA;AC2dJ;ADvdA;EACE,aAAA;ACydF;ADtdA;EACE,oBAAA;ACwdF;ADrdA;EACE,cAAA;ACudF;ADpdA;EACE,qBAAA;ACsdF;ADndA;EACE,eAAA;ACqdF;ADldA;EACE,mBAAA;ACodF;ADjdA;EACE,sBAAA;ACmdF;ADhdA;EACE,iBAAA;ACkdF;AD/cA;EACE,WAAA;EACA,YAAA;ACidF;AD9cA;EACE,SAAA;ACgdF;AD7cA;EACE,UAAA;AC+cF;AD5cA;EACE,UAAA;AC8cF;AD3cA;EACE,sBAAA;AC6cF;AD1cA;EACE,WAAA;AC4cF;ADzcA;EACE,aAAA;AC2cF;ADxcA;EACE,UAAA;AC0cF;ADvcA;EACE,UAAA;ACycF;ADtcA;EACE,UAAA;ACwcF;ADrcA;EACE,UAAA;ACucF;ADpcA;EACE,UAAA;ACscF;ADncA;EACE,aAAA;ACqcF;ADlcA;EACE,cAAA;ACocF;ADjcA;EACE,cAAA;ACmcF;ADhcA;EACE,eAAA;ACkcF;AD/bA;EACE,cAAA;ACicF;AD9bA;EACE,UAAA;ACgcF;AD7bA;EACE,WAAA;AC+bF;AD5bA;EACE,WAAA;AC8bF;AD3bA;EACE,uBAAA;AC6bF;AD1bA;EACE,uBAAA;AC4bF;ADzbA;EACE,YAAA;AC2bF;ADxbA;EACE,eAAA;AC0bF;ADvbA;EACE,SAAA;ACybF;ADtbA;EACE,aAAA;ACwbF;ADrbA;EACE,0BAAA;ACubF;ADpbA;EACE,eAAA;ACsbF;ADnbA;EACE,4BAAA;ACqbF;ADlbA;EACE,gBAAA;ACobF;ADjbA;EACE,+BAAA;ACmbF;ADhbA;EACE,cAAA;ACkbF;AD/aA;EACE,0BAAA;ACibF;AD9aA;EACE,iBAAA;EACA,kBAAA;ACgbF;AD7aA;EACE,uBAAA;AC+aF;AD5aA;EACE,uBAAA;AC8aF;AD3aA;EACE,uBAAA;AC6aF;AD1aA;EACE,YAAA;AC4aF;ADzaA;EACE,wBAAA;AC2aF;ADxaA;EACE,aAAA;AC0aF;ADvaA;EACE,aAAA;ACyaF;ADtaA;EACE,aAAA;ACwaF;ADraA;EACE,yBAAA;ACuaF;ADpaA;EACE,2BAAA;ACsaF;ADnaA;EACE,6BAAA;ACqaF;ADlaA;EACE,eAAA;ACoaF;ADjaA;EACE,gBAAA;ACmaF;ADhaA;EACE,4BAAA;ACkaF;AD/ZA;EACE,8BAAA;ACiaF;AD9ZA;EACE,YAAA;ACgaF;AD7ZA;EA/BE,yBAAA;EAoBA,4BAAA;AC4aF;AD5ZA;EApBE,gBAAA;EAJA,eAAA;ACwbF;AD3ZA;EACE,cAAA;AC6ZF;AD1ZA;EACE,gBAAA;AC4ZF;ADzZA;EACE,gBAAA;AC2ZF;ADxZA;EACE,2BAAA;AC0ZF;ADvZA;EACE,4BAAA;ACyZF;ADtZA;EACE,kBAAA;ACwZF;ADrZA;EACE,qCAAA;ACuZF;ADpZA;EACE,iBAAA;ACsZF;ADnZA;EACE,8BAAA;ACqZF;ADlZA;EACE,sBAAA;ACoZF;ADjZA;EACE,uBAAA;ACmZF;ADhZA;EACE,mBAAA;ACkZF;AD/YA;EACE,kBAAA;ACiZF;AD9YA;EACE,sBAAA;ACgZF;AD7YA;EACE,gCAAA;AC+YF;AD5YA;EACE,uBAAA;AC8YF;AD3YA;EACE,sBAAA;AC6YF;AD1YA;EACE,yBAAA;AC4YF;ADzYA;EACE,8BAAA;AC2YF;ADxYA;EACE,2BAAA;AC0YF;ADvYA;EACE,YAAA;ACyYF;ADtYA;EACE,yBAAA;ACwYF;ADrYA;EACE,oBAAA;ACuYF;ADpYA;EA/UE,aAAA;EAoBA,mBAAA;ACmsBF;ADnYA;EApVE,aAAA;EAwBA,sBAAA;ACmsBF;ADlYA;EACE,2BAAA;EACA,uBAAA;ACoYF;ADjYA;EACE,eAAA;ACmYF;ADhYA;EACE,0BAAA;ACkYF;AD/XA;EACE,kBAAA;ACiYF;AD9XA;EACE,gBAAA;ACgYF;AD7XA;EACE,UAAA;EACA,qBAAA;AC+XF;AD5XA;EACE,kBAAA;AC8XF;AD3XA;EACE,uBAAA;AC6XF;AD1XA;EACE,uBAAA;AC4XF;ADzXA;EACE,YAAA;AC2XF;ADxXA;EACE,aAAA;AC0XF;ADxXA;EACE,2BAAA;AC0XF;ADvXA;EACE,yBAAA;ACyXF;ADtXA;EACE,2BAAA;ACwXF;ADrXA;EACE,SAAA;ACuXF;ADpXA;EACE,yBAAA;ACsXF;ADnXA;EACE,UAAA;ACqXF;ADlXA;EACE,SAAA;ACoXF;ADvWE;EA5aA,aAAA;EAwBA,sBAAA;EAkUA,2BAAA;EACA,uBAAA;EA3TA,WAAA;EACA,YAAA;EA+YE,UAAA;AC4WJ;ADjXA;EA3aE,aAAA;EAoBA,mBAAA;EAwSA,8BAAA;EA5BA,mBAAA;EAuIA,WAAA;EACA,YAAA;AC4XF;ADzXA;EAjPE,wBAAA;EA1LA,aAAA;EAwbI,cAAA;EACA,iBAAA;EACA,eAAA;ACiXN;ADhYA;EA3aE,aAAA;EAoBA,mBAAA;EAwSA,8BAAA;EA5BA,mBAAA;EAuIA,WAAA;EACA,YAAA;AC2YF;ADxYA;EAvZE,mBAAA;EAwSA,8BAAA;EA5RA,WAAA;EACA,YAAA;EAqaE,gBAAA;EACA,6BAAA;ACoXJ;ADhZA;EAgCI,WAAA;ACmXJ;AD/WA;EA/cE,aAAA;EAoBA,mBAAA;EA8bA,iBAAA;ACiXF;ADpXA;EAhHE,eAAA;EAuHE,0BAAA;EACA,WAAA;ACiXJ;AD5WE;EA5dA,aAAA;EAoBA,mBAAA;EAsUA,2BAAA;EACA,uBAAA;ACmfF;ADnXA;EA3dE,aAAA;EAoBA,mBAAA;EA+cE,8BAAA;EACA,mBAAA;EApcF,WAAA;EACA,YAAA;EAqcE,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,iCAAA;ACiXJ;AD/XA;EA3dE,aAAA;EAoBA,mBAAA;EA0dE,2BAAA;EACA,mBAAA;ACiXJ;ADrYA;EAwBI,SAAA;ACgXJ;ADxYA;EA5HE,eAAA;EAyJE,cAAA;AC+WJ;AD3WA;EA7JE,eAAA;EA+JA,uBAAA;EAxUA,uBAAA;ACsrBF;ADhXA;EAMI,YAAA;EACA,WAAA;AC6WJ;ADxWE;EACE,UAAA;EACA,WAAA;AC0WJ;ADvWE;EACE,WAAA;EACA,YAAA;EAvgBF,cAAA;EA6BA,SAAA;EA6eE,mBAAA;EACA,yBAAA;EACA,6CAAA;EACA,mBAAA;ACyWJ;ADrWA;EArSE,cAAA;EAuSA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;ACuWF;AD/WA;EAWI,eAAA;EACA,oBAAA;ACuWJ;ADnWA;EACE,uBAAA;EACA,2BAAA;ACqWF;ADlWA;EAnKE,yBAAA;EAsKE,iBAAA;EACA,eAAA;EACA,+CAAA;EACA,YAAA;EACA,2BAAA;ACmWJ;AD1WA;EAWI,YAAA;ACkWJ;AD7WA;EAeI,2BAAA;ACiWJ;ADhXA;EAvME,kBAAA;EA2NE,UAAA;EACA,QAAA;EACA,YAAA;ACgWJ;AD5VA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AC8VF;AD3VA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AC6VF;AD1VA;EACE,YAAA;EACA,aAAA;EACA,YAAA;AC4VF;ADzVA;EA3lBE,aAAA;EA6lBA,wBAAA;AC2VF;ADxVA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AC0VF;ADvVA;EACE,eAAA;EACA,YAAA;ACyVF;ADtVA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;ACwVF;ADrVA;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;ACuVF;ADpVA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;ACsVF;ADnVA;EACE,oCAAA;ACqVF;ADlVA;EACE,cAAA;EACA,iBAAA;ACoVF;ADjVA;EACE,cAAA;EACA,0BAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;ACmVF;ADxVA;EAQI,aAAA;EACA,mBAAA;EACA,2BAAA;ACmVJ;AD/UA;EACE,cAAA;EACA,WAAA;EACA,YAAA;ACiVF;AD9UA;EACE,2BAAA;ACgVF;AD7UA;EACE,YAAA;AC+UF;AD5UA;EACE,2BAAA;EACA,YAAA;AC8UF;AD3UA;EACE,YAAA;EACA,kBAAA;AC6UF;AD1UA;EACE,yBAAA;AC4UF;ADzUA;EACE,kCAAA;EACA,iCAAA;EACA,gBAAA;EACA,6BAAA;AC2UF;ADxUA;EACE,4BAAA;EACA,+BAAA;AC0UF;ADxUA;EACE,4BAAA;EACA,+BAAA;AC0UF;ADxUA;EACE,kBAAA;EACA,sBAAA;AC0UF;ADvUA;EACE,sBAAA;ACyUF;ADvUA;EACE,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;ACyUF;AD7UA;EAOI,aAAA;EACA,iBAAA;ACyUJ;ADrUA;EACE,aAAA;EACA,yBAAA;ACuUF;ADpUA;EACE,yBAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;ACsUF;ADnUA;EACE,yBAAA;EACA,sBAAA;EACA,uBAAA;ACqUF;ADlUA;EACE,yBAAA;EACA,sBAAA;EACA,uBAAA;ACoUF;ADjUA;EACE,qBAAA;ACmUF;AD/TE;EAnvBA,aAAA;EAoBA,mBAAA;EA4SA,2BAAA;EAhCA,mBAAA;EAwdE,WAAA;EACA,aAAA;ACiUJ;ADxUA;EA3VE,yBAAA;EAuWE,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;ACgUJ;ADnVA;EAuBI,iBAAA;AC+TJ;AD3TA;EACE,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;AC6TF;ADlUA;EAQI,2BAAA;EACA,8BAAA;EACA,kBAAA;AC6TJ;ADvUA;EAeI,8BAAA;AC2TJ;AD1UA;EAoBI,6BAAA;EACA,qBAAA;EACA,sBAAA;ACyTJ;ADrTA;EACE,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;ACuTF;AD7TA;EASI,gBAAA;EACA,2BAAA;ACuTJ;ADjUA;EAcI,UAAA;EACA,SAAA;ACsTJ;ADrUA;EAmBI,0BAAA;EACA,aAAA;EA3zBF,aAAA;EAoBA,mBAAA;EA4RA,uBAAA;EAhBA,mBAAA;ACo1BF;AD7UA;EAvyBE,aAAA;EAwBA,sBAAA;EAwQA,mBAAA;EAqiBI,YAAA;EACA,8BAAA;ACqTN;ADpVA;EAkCQ,YAAA;EACA,WAAA;ACqTR;ADxVA;EAvyBE,aAAA;EAwBA,sBAAA;AC2mCF;AD9SA;EACE,yBAAA;EA3cA,oCAAA;AC4vBF;AD7SA;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,8BAAA;EACA,2BAAA;EACA,kBAAA;AC+SF;AD5SA;EACE,0BAAA;EACA,oBAAA;EACA,UAAA;AC8SF;AD3SA;EACE,0BAAA;EACA,WAAA;AC6SF;AD/SA;EAKI,kBAAA;EACA,WAAA;EACA,mBAAA;AC6SJ;ADzSA;EAKE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;ACuSF;ADjTA;EAEI,cAAA;ACkTJ;ADvSA;EACE,gBAAA;EACA,eAAA;ACySF;ADtSA;EACE,uBAAA;EACA,2BAAA;ACwSF;ADrSA;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,gCAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;ACuSF;ADpSA;EACE,mBAAA;EACA,gBAAA;EACA,YAAA;ACsSF;ADnSA;EACE,UAAA;EACA,mBAAA;ACqSF;ADlSA;EACE,WAAA;EACA,mBAAA;EACA,eAAA;ACoSF;ADjSA;EACE,cAAA;EACA,mBAAA;ACmSF;ADhSA;EAhqBE,qCAAA;EAoBA,mBAAA;EAYA,gCAAA;EA5CA,2BAAA;EAirBA,gBAAA;EACA,YAAA;EACA,qCAAA;ACkSF;AD/RA;EACE,yBAAA;EACA,8BAAA;EACA,2BAAA;ACiSF;AD9RA;EAhrBE,qCAAA;EAoBA,mBAAA;EAgBA,uBAAA;EAgpBA,gBAAA;EACA,YAAA;EACA,qCAAA;ACgSF;AD7RA;EACE,yBAAA;EACA,2BAAA;AC+RF;AD5RA;EACE,mBAAA;EACA,eAAA;EACA,eAAA;EAEA,kBAAA;EACA,mBAAA;AC6RF;AD1RA;EACE,4BAAA;AC4RF;ADzRA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AC2RF;ADxRA;EACE,YAAA;AC0RF;ADvRA;EACE,4BAAA;ACyRF;ADtRA;EACE,uBAAA;EACA,2BAAA;ACwRF;ADrRA;EACE,wCAAA;ACuRF;ADpRA;EACE,2BAAA;ACsRF;ADnRA;EACE,0BAAA;ACqRF;ADlRA;EACE,iBAAA;ACoRF;ADjRA;EACE,iBAAA;EAv0BA,YAAA;AC2lCF;ADhRA;EACE,uBAAA;ACkRF;AD/QA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;ACiRF;AD9QA;EACE,+BAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;ACgRF;ADpRA;EAOI,gBAAA;ACgRJ;ADvRA;EAWI,cAAA;AC+QJ;AD1RA;EAeI,cAAA;AC8QJ;AD7RA;EAmBI,cAAA;AC6QJ;ADhSA;EAuBI,WAAA;EACA,eAAA;EACA,gBAAA;AC4QJ;ADrSA;EA+BM,0BAAA;EACA,6BAAA;ACyQN;ADzSA;EAqCM,8BAAA;ACuQN;ADlQA;EACE,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;ACoQF;ADjQA;EACE,sBAAA;ACmQF;ADpQA;EAIM,0BAAA;ACmQN;AD9PA;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;ACgQF;AD9PE;EACE,iCAAA;ACgQJ;AD7PE;EACE,qBAAA;AC+PJ;AD5PE;EACE,yBAAA;EACA,qBAAA;AC8PJ;AD3PE;EACE,cAAA;AC6PJ;AD1PE;EACE,0BAAA;AC4PJ;ADxPA;EACE,8BAAA;AC0PF;ADvPA;EACE,cAAA;EACA,WAAA;ACyPF;ADtPA;EACE,aAAA;EACA,UAAA;EACA,YAAA;ACwPF;ADrPA;EACE,gBAAA;EACA,2BAAA;ACuPF;ADpPA;EACE,uBAAA;ACsPF;ADrPE;EACE,mBAAA;ACuPJ;ADtPI;;EAEE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;ACwPN;ADtPI;EACE,YAAA;EACA,UAAA;EACA,YAAA;ACwPN;ADtPI;EACE,YAAA;EACA,UAAA;EACA,YAAA;ACwPN;ADrPE;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;ACuPJ;ADnPA;EACE,4BAAA;EACA,cAAA;ACqPF;ADlPA;EACE,wBAAA;EACA,mCAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;ACoPF;ADnPE;EACE,YAAA;EACA,6BAAA;ACqPJ;ADjPA;EACE,2BAAA;ACmPF;ADhPA;EACE,gBAAA;EACA,kBAAA;ACkPF;AD/OA;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;ACiPF;AD9OA;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;ACgPF;AD7OA;EACE,kBAAA;AC+OF;ADhPA;EAgBI,0BAAA;EAvtCF,aAAA;EAwBA,sBAAA;EAorCE,gBAAA;EACA,cAAA;EACA,0BAAA;ACiPJ;ADxPA;EAUI,uBAAA;EACA,qBAAA;EACA,cAAA;ACiPJ;AD7PA;EAeI,cAAA;EACA,0BAAA;ACiPJ;AD7OA;EACE,0BAAA;EACA,yBAAA;AC+OF;AD7OA;EACE,WAAA;EACA,gCAAA;AC+OF;AD7OA;EACE,cAAA;EACA,2CAAA;EACA,gCAAA;AC+OF;AD5OA;EACE,0BAAA;AC8OF;AD3OA;EACE,iCAAA;EACA,qBAAA;AC6OF;AD1OA;EACE,YAAA;AC4OF;ADzOA;EACE,aAAA;EACA,gBAAA;AC2OF;ADxOA;EACE,0BAAA;EACA,4BAAA;AC0OF;ADvOA;EACE,YAAA;ACyOF;ADtOA;EACE,aAAA;EACA,yBAAA;ACwOF;ADtOA;EACE,oBAAA;EACA,YAAA;ACwOF;ADtOA;EACE,oBAAA;EACA,UAAA;ACwOF;ADrOA;EACE,uBAAA;ACuOF;ADpOA;EACE,yBAAA;EACA,YAAA;ACsOF;ADnOA;EACE,yBAAA;EACA,YAAA;ACqOF;ADlOA;EACE,qBAAA;EACA,YAAA;ACoOF;ADjOA;EACE,yBAAA;EACA,YAAA;ACmOF;ADhOA;EACE,gBAAA;EACA,yBAAA;EACA,YAAA;ACkOF;AD/NA;EACE,gBAAA;EACA,qBAAA;EACA,YAAA;ACiOF;AD9NA;EACE,6BAAA;EACA,QAAA;ACgOF;AD7NA;EACE,4CAAA;AC+NF;AD5NA;EA/9BE,eAAA;EAi+BA,qCAAA;EACA,sBAAA;AC8NF;AD3NA;EC6NE,oCAAoC;ED3NpC,aAAA;EACA,sBAAA;EACA,OAAA;EC6NA,4BAA4B;ED5N5B,cAAA;EC8NA,yCAAyC;ED7NzC,WAAA;AC+NF;AD5NA;EACE,YAAA;EC8NA,4BAA4B;AAC9B;AD5NA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EC8NA,iCAAiC;ED7NjC,aAAA;EACA,cAAA;AC+NF;AD5NA;EACE,WAAA;AC8NF;AD3NA;EACE,WAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AC6NF;AD1NA;EACE,iBAAA;AC4NF;ADzNA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AC2NF;ADxNA;EAl3CE,aAAA;EAoBA,mBAAA;EA4QA,mBAAA;AC+yCF;ADxNA;EACE,YAAA;AC0NF;ADvNA;EACE,uBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;ACyNF;ADtNA;EAEI,qBAAA;EACA,wBAAA;EACA,0BAAA;ACuNJ;AD3NA;EAQI,aAAA;ECsNF,6CAA6C;EDrN3C,mBAAA;ECuNF,yCAAyC;EDtNvC,sBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;ACwNJ;ADrOA;ECuOE,sCAAsC;EDrNpC,kBAAA;EACA,sBAAA;EACA,iBAAA;ACuNJ;AD3OA;EAwBI,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;ACsNJ;ADlPA;EAgCI,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;ACqNJ;AD3PA;EAyCI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,wBAAA;ACqNJ;ADjQA;EA8CM,0BAAA;ACsNN;ADpQA;EAiDM,wBAAA;EACA,uBAAA;EACA,mBAAA;ACsNN;ADjNA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;ACmNF;ADvNA;EAMI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;ACoNJ;AD/NA;EAaM,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;ACqNN;ADtOA;EAmBQ,gBAAA;ACsNR;ADhNA;EACE,qBAAA;ACkNF;AD/MA;EAEI,0BAAA;ACgNJ;ADlNA;EAKI,0BAAA;ACgNJ;AD5MA;EAptCE,qCAAA;EAstCA,UAAA;AC8MF;AD3MA;EAEI,4BAAA;AC4MJ;AD9MA;EAMI,qBAAA;EACA,uCAAA;AC2MJ;ADlNA;EAYM,4BAAA;ACyMN;ADrNA;EAgBM,uCAAA;ACwMN;ADxNA;EAqBI,qBAAA;ACsMJ;AACA,oCAAoC","sourcesContent":["html,\nbody,\n#root {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  font-size: small;\n\n  &#root {\n    overflow: hidden;\n  }\n}\n\nbody {\n  font-family: 'NeueFrutigerWorldW02-Regular', sans-serif !important;\n  overflow: hidden;\n}\n\nbody * {\n  font-family: 'NeueFrutigerWorldW02-Regular', sans-serif !important;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n@font-face {\n  font-family: 'NeueFrutigerWorldW02-Regular';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url('../public/NeueFrutigerWorldW02-Regular.woff2');\n}\n\n@import url(./category.less);\n\n@philips-blue: #1474a4;\n@philips-gray: #eeeeee;\n@philips-green: #93c47d;\n@philips-orange: #f7d368;\n@philips-yellow: #f3f66b;\n@philips-red: red;\n\n@dialogActionDivider: rgba(0, 0, 0, 0.12);\n\n// Badge styling for filter/column counters\n.small-badge {\n  .MuiBadge-badge {\n    font-size: 0.65rem;\n    height: 16px;\n    min-width: 16px;\n    padding: 0 4px;\n  }\n}\n\n//Scroll bar Stylings\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #5a9dbf;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #5a9dbf;\n}\n\n.footer {\n  &.root {\n    .d-flex();\n    .w-100();\n    font-size: 12px;\n  }\n\n  .env {\n    margin-right: 1px;\n    padding-right: 1px;\n  }\n\n  .termsAndCondition {\n    .d-flex();\n    .flex-row();\n    margin-right: 1px;\n  }\n\n  border-top: 0.1rem solid rgba(0, 0, 0, 0.12);\n  color: black;\n  margin-right: 1px;\n\n  .d-flex();\n  .flex-row();\n\n  &.bg-gray {\n    background-color: @philips-gray;\n  }\n\n  &.bg-green {\n    background-color: @philips-green;\n  }\n\n  &.bg-orange {\n    background-color: @philips-orange;\n  }\n\n  &.bg-yellow {\n    background-color: @philips-yellow;\n  }\n}\n\n.termsAndCondition-dialog {\n  .paperClass {\n    width: 45%;\n    height: 60vh;\n  }\n}\n\n.d-flex {\n  display: flex;\n}\n\n.d-inline-flex {\n  display: inline-flex;\n}\n\n.d-block {\n  display: block;\n}\n\n.d-inline-block {\n  display: inline-block;\n}\n\n.d-inline {\n  display: inline;\n}\n\n.flex-row {\n  flex-direction: row;\n}\n\n.flex-column {\n  flex-direction: column;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap;\n}\n\n.squareSize {\n  width: 100%;\n  height: 100%;\n}\n\n.w-0 {\n  width: 0%;\n}\n\n.w-25 {\n  width: 25%;\n}\n\n.w-50 {\n  width: 50%;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto;\n}\n\n.w-25ch {\n  width: '25ch';\n}\n\n.w-10 {\n  width: 10%;\n}\n\n.w-20 {\n  width: 20%;\n}\n\n.w-40 {\n  width: 40%;\n}\n\n.w-45 {\n  width: 45%;\n}\n\n.w-90 {\n  width: 90%;\n}\n\n.mw-0 {\n  max-width: 0%;\n}\n\n.mw-25 {\n  max-width: 25%;\n}\n\n.mw-50 {\n  max-width: 50%;\n}\n\n.mw-100 {\n  max-width: 100%;\n}\n\n.mw-10 {\n  max-width: 10%;\n}\n\n.h-0 {\n  height: 0%;\n}\n\n.h-25 {\n  height: 25%;\n}\n\n.h-50 {\n  height: 50%;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-90vh {\n  height: 90vh !important;\n}\n\n.h-auto {\n  height: auto;\n}\n\n.h-inherit {\n  height: inherit;\n}\n\n.m-0 {\n  margin: 0;\n}\n\n.mt-0 {\n  margin-top: 0;\n}\n\n.mt-1em {\n  margin-top: 1em !important;\n}\n\n.mr-0 {\n  margin-right: 0;\n}\n\n.mr-5px {\n  margin-right: 5px !important;\n}\n\n.mb-0 {\n  margin-bottom: 0;\n}\n\n.mb-05em {\n  margin-bottom: 0.5em !important;\n}\n\n.ml-0 {\n  margin-left: 0;\n}\n\n.ml-1 {\n  margin-left: 1% !important;\n}\n\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.p-0 {\n  padding: 0px !important;\n}\n\n.p-1 {\n  padding: 1px !important;\n}\n\n.p-3px {\n  padding: 3px !important;\n}\n\n.p-5px {\n  padding: 5px;\n}\n\n.p-10px {\n  padding: 10px !important;\n}\n\n.p-20px {\n  padding: 20px;\n}\n\n.p-15px {\n  padding: 15px;\n}\n\n.p-1rem {\n  padding: 1rem;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 1em !important;\n}\n\n.pr-1 {\n  padding-right: 1em !important;\n}\n\n.pl-0 {\n  padding-left: 0;\n}\n\n.pr-0 {\n  padding-right: 0;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 1em !important;\n}\n\n.float-right {\n  float: right;\n}\n\n.py-0 {\n  .pt-0();\n  .pb-0();\n}\n\n.px-0 {\n  .pr-0();\n  .pl-0();\n}\n\n.overflow-auto {\n  overflow: auto;\n}\n\n.overflowX-auto {\n  overflow-x: auto;\n}\n\n.overflowY-auto {\n  overflow-y: auto;\n}\n\n.text-left {\n  text-align: left !important;\n}\n\n.text-right {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n\n.ws-nowrap {\n  white-space: nowrap !important;\n}\n\n.vertical-middle {\n  vertical-align: middle;\n}\n\n.align-top {\n  align-items: flex-start;\n}\n\n.align-center {\n  align-items: center;\n}\n\n.alignself-center {\n  align-self: center;\n}\n\n.alignself-start {\n  align-self: self-start;\n}\n\n.justify-left {\n  justify-content: left !important;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-right {\n  justify-content: right;\n}\n\n.justify-end {\n  justify-content: flex-end;\n}\n\n.justify-spacebetween {\n  justify-content: space-between;\n}\n\n.justify-start {\n  justify-content: flex-start;\n}\n\n.cursor-move {\n  cursor: move;\n}\n\n.warning {\n  color: @philips-orange !important;\n}\n\n.bottomUnset {\n  border-bottom: unset;\n}\n\n.rowFlex {\n  .d-flex();\n  .flex-row();\n}\n\n.colFlex {\n  .d-flex();\n  .flex-column();\n}\n\n.flex-start {\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-default {\n  cursor: default !important;\n}\n\n.position-absolute {\n  position: absolute;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.textWidth50 {\n  width: 50%;\n  display: inline-block;\n}\n\n.overflowY-hidden {\n  overflow-y: hidden;\n}\n\n.overflow-ellipsis {\n  text-overflow: ellipsis;\n}\n\n.overflowWrap-anywhere {\n  overflow-wrap: anywhere;\n}\n\n.zindex-100 {\n  z-index: 100;\n}\n\n.zindex-2000 {\n  z-index: 2000;\n}\n.border-radius-0 {\n  border-radius: 0 !important;\n}\n\n.bg-philips-blue {\n  background-color: @philips-blue;\n}\n\n.bg-lightgray {\n  background-color: lightgray;\n}\n\n.b-0 {\n  border: 0;\n}\n\n.philipsBlue {\n  color: @philips-blue !important;\n}\n\n.PhilipsRed {\n  color: @philips-red;\n}\n\n.zoom80 {\n  zoom: 80%;\n}\n\n.secondaryHeader(@h: 38px) {\n  .d-flex();\n  .flex-row();\n  .justify-spacebetween();\n  .align-center();\n  width: 100%;\n  height: @h;\n}\n\n.appRouter {\n  &.root {\n    .colFlex();\n    .flex-start();\n    .squareSize();\n    padding: 0;\n  }\n\n  .secondaryHeader {\n    .secondaryHeader(38px);\n    .headername {\n      .p-10px();\n      .d-flex();\n      color: @philips-blue;\n      font-weight: bold;\n      font-size: 14px;\n    }\n  }\n\n  .secondaryHeaderTabs {\n    .secondaryHeader(auto);\n  }\n\n  .appRouterContent {\n    .flex-row();\n    .justify-spacebetween();\n    .squareSize();\n    overflow: hidden;\n    width: -webkit-fill-available;\n  }\n\n  .divider {\n    width: 100%;\n  }\n}\n\n.termsAndConditionStyle {\n  .d-flex();\n  .flex-row();\n  margin-right: 1px;\n\n  .title {\n    .cursor-pointer();\n    text-decoration: underline;\n    color: blue;\n  }\n}\n\n.headerStyle {\n  &.root {\n    .rowFlex();\n    .flex-start();\n  }\n\n  .toolbar {\n    .rowFlex();\n    justify-content: space-between;\n    align-items: center;\n    .squareSize();\n    padding: 0 10px;\n    min-height: 3rem;\n    padding-top: 0.3rem !important;\n    padding-bottom: 0.3rem !important;\n  }\n\n  .toolbarSection {\n    .rowFlex();\n    justify-content: flex-start;\n    align-items: center;\n  }\n\n  .tooltip {\n    margin: 2;\n  }\n\n  .button-icon {\n    .cursor-pointer();\n    color: #ffffff;\n  }\n}\n\n.userPanelIconButton {\n  .cursor-pointer();\n  color: white !important;\n  .p-5px() !important;\n\n  .userProfileIcon {\n    height: 2rem;\n    width: 2rem;\n  }\n}\n\n.popperStyle {\n  &.arrow {\n    width: 3em;\n    height: 3em;\n  }\n\n  &::before {\n    content: '';\n    margin: auto;\n    .d-block();\n    .w-0();\n    border-style: solid;\n    border-width: 0px 1em 1em;\n    border-color: transparent transparent rgb(255, 255, 255);\n    margin-top: -0.4rem;\n  }\n}\n\n.middle-container {\n  .overflow-auto();\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 100% !important;\n  padding: 0.5em 1em;\n\n  .mainHeader {\n    margin-top: 0em;\n    margin-bottom: 0.2em;\n  }\n}\n\n.common-dialog-paper {\n  width: 550px !important;\n  min-width: 550px !important;\n}\n\n.common-dialog-style {\n  .header {\n    .bg-philips-blue();\n    font-size: 1.2rem;\n    padding: 0.5rem;\n    border-bottom: 0.1rem solid @dialogActionDivider;\n    color: white;\n    text-align: left !important;\n  }\n\n  .paper {\n    height: 60vh;\n  }\n\n  .dialogContent {\n    padding-top: 4vh !important;\n  }\n\n  .closeIcon {\n    .position-absolute();\n    right: 0px;\n    top: 0px;\n    color: white;\n  }\n}\n\n.landing-Page-body {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.header4 {\n  font-size: large;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-left: 10px;\n}\n\n.catalog-Container {\n  width: 376px;\n  height: 100px;\n  padding: 5px;\n}\n\n.catalog-cardLayout {\n  .d-flex();\n  padding: 10px !important;\n}\n\n.catalog-image {\n  height: 80px;\n  width: 80px;\n  margin-left: 5px;\n  margin-top: 5px;\n}\n\n.catalog-info {\n  flex-basis: 90%;\n  padding: 5px;\n}\n\n.catalog-productDescription {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  width: 34ch;\n}\n\n.noData-label {\n  width: 50%;\n  margin-left: 45%;\n  padding-top: 15%;\n}\n\n.catalog-icon {\n  display: flex;\n  flex-basis: 10%;\n  padding: 5px;\n  cursor: pointer;\n}\n\n.catalog-create {\n  background-color: @philips-blue !important;\n}\n\n.productCatalogCardHeader {\n  color: rgb(20, 116, 164);\n  font-weight: bold;\n}\n\n.list-Section {\n  display: block;\n  height: calc(90% - 8.6rem);\n  padding: 0px 10px 10px 10px;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  ul > div {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n  }\n}\n\n.list-Section-Tab {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.list-Items {\n  padding-top: 0px !important;\n}\n\n.list-Section::-webkit-scrollbar {\n  height: 10px;\n}\n\n.list-ItemsContainer {\n  margin-left: 0px !important;\n  padding: 5px;\n}\n\n.recordsPerPage {\n  height: 30px;\n  margin-right: 15px;\n}\n\n.recordsPerPage > div {\n  padding: 8.5px !important;\n}\n\n.refresh-button {\n  min-height: min-content !important;\n  min-width: min-content !important;\n  padding: 6px 8px;\n  position: relative !important;\n}\n\n.procos-export-button {\n  margin-left: 30px !important;\n  text-transform: none !important;\n}\n.pcs-export-button {\n  margin-left: 40px !important;\n  text-transform: none !important;\n}\n.refresh-button > span {\n  padding-right: 2px;\n  margin: 0px !important;\n}\n\n.export-button > span {\n  margin: 4px !important;\n}\n.recordsChange-conatiner {\n  display: flex;\n  flex-direction: row-reverse;\n  margin-right: 10px;\n  align-items: center;\n\n  .form-control {\n    width: 5.5rem;\n    margin-left: 10px;\n  }\n}\n\n.Records {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.home-icon {\n  color: @philips-blue !important;\n  width: 100%;\n  padding: 3px !important;\n  margin: 0px !important;\n}\n\n.action-icon {\n  color: @philips-blue !important;\n  margin: 0px !important;\n  padding: 2px !important;\n}\n\n.action-icon-disabled {\n  color: @philips-gray !important;\n  margin: 0px !important;\n  padding: 3px !important;\n}\n\n.form-text {\n  color: @philips-red !important;\n}\n\n.breadCrumb {\n  &.root {\n    .d-flex();\n    .flex-row();\n    .justify-start();\n    .align-center();\n    width: 100%;\n    padding: 10px;\n  }\n\n  .item {\n    .philipsBlue();\n    text-overflow: ellipsis;\n    display: block;\n    white-space: nowrap;\n    overflow: hidden;\n    cursor: pointer;\n    text-decoration: none;\n    font-size: 1rem;\n    font-weight: bold;\n  }\n\n  .activeItem {\n    font-weight: bold;\n  }\n}\n\n.search-bar.MuiAutocomplete-root {\n  width: 20em !important;\n  position: relative;\n  bottom: 3px;\n  right: 20px;\n  padding-top: 0.3rem;\n\n  .search-inner-text > div {\n    padding-top: 0px !important;\n    padding-bottom: 0px !important;\n    margin-left: 0.7vw;\n  }\n\n  .search-inner-text > div > div > button {\n    // To make the clear icon visible\n    visibility: visible !important;\n  }\n\n  .search-inner-text > div > div > svg {\n    // To set the icon in place\n    position: absolute !important;\n    top: 1.1vh !important;\n    left: 0.2vw !important;\n  }\n}\n\n.unsupported-browser {\n  display: inline-block;\n  text-align: center;\n  width: 45%;\n  height: 90%;\n  margin-left: auto;\n  margin-right: auto;\n\n  .message {\n    text-align: left;\n    padding-top: 5px !important;\n  }\n\n  .unsupported-browser-image {\n    height: 50;\n    width: 40;\n  }\n\n  .versionSupported {\n    z-index: 150000 !important;\n    padding: 10px;\n    .d-flex();\n    .flex-row();\n    .justify-center();\n    .align-center();\n\n    .browserBox {\n      .d-flex();\n      .flex-column();\n      .align-center();\n      margin: 0 2%;\n      justify-content: space-between;\n\n      img {\n        height: 35px;\n        width: 35px;\n      }\n\n      .browserDetails {\n        .d-flex();\n        .flex-column();\n      }\n    }\n  }\n}\n\n.activeIcon {\n  color: @philips-gray !important;\n  .bg-philips-blue() !important;\n}\n\n.languageContainer {\n  font-size: 1rem !important;\n  padding: 0px !important;\n  vertical-align: middle !important;\n  align-items: center !important;\n  border-radius: 0 !important;\n  width: max-content;\n}\n\n.data-table {\n  height: calc(90% - 8.6rem);\n  padding-bottom: 10px;\n  width: 60%;\n}\n\n.features-table {\n  height: calc(90% - 8.6rem);\n  width: 100%;\n\n  .recordPicker {\n    position: relative;\n    bottom: 3px;\n    padding-top: 0.3rem;\n  }\n}\n\n.alert-dialog {\n  .MuiDialog-container .MuiPaper-root {\n    min-width: 40%;\n  }\n\n  display: inline-block;\n  width: 45%;\n  height: 90%;\n  margin-left: auto;\n  margin-right: auto;\n  min-width: 30%;\n}\n\n.autocomplete-div {\n  margin-top: 0.3%;\n  flex-basis: 35%;\n}\n\n.tab-Panel {\n  height: 20px !important;\n  min-height: 20px !important;\n}\n\n.loading-message {\n  display: block;\n  text-align: center;\n  background: white;\n  padding: 50px;\n  box-shadow: 1px 1px 2px 1px grey;\n  border-radius: 3px;\n  width: 30%;\n  min-width: 30%;\n}\n\n.manage-tab-pagination {\n  align-items: center;\n  margin-top: 1rem;\n  height: 8rem;\n}\n\n.procos-pagination {\n  width: 60%;\n  align-items: center;\n}\n\n.procos-features-pagination {\n  width: 100%;\n  align-items: center;\n  padding-top: 1%;\n}\n\n.common-btn {\n  height: 2.5rem;\n  white-space: nowrap;\n}\n\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.tab-drawer-tabs {\n  .text-capitalize();\n  .align-center();\n  .justify-left();\n  .text-left();\n  min-height: 30px;\n  padding: 7px;\n  color: rgba(0, 0, 0, 0.87) !important;\n}\n\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected.tab-drawer-tabs {\n  color: #1474a4 !important;\n  background: rgba(199, 224, 244, 1) !important;\n  font-weight: 800 !important;\n}\n\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.pdm-tabs {\n  .text-capitalize();\n  .align-center();\n  .justify-center();\n  min-height: 30px;\n  padding: 7px;\n  color: rgba(0, 0, 0, 0.87) !important;\n}\n\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected.pdm-tabs {\n  color: #1474a4 !important;\n  font-weight: 800 !important;\n}\n\n.navigateTabLabel {\n  writing-mode: tb-rl;\n  height: inherit;\n  cursor: pointer;\n\n  font-size: 1.25rem;\n  white-space: nowrap;\n}\n\n.pinIcon {\n  font-size: 1.4rem !important;\n}\n\n.tabDrawerMini {\n  width: 4.5rem;\n  height: auto;\n  text-align: center;\n  background: #eeeeee;\n  z-index: 100;\n}\n\n.drawerOpen {\n  width: 200px;\n}\n\n.drawer-tab {\n  min-height: 500px !important;\n}\n\n.pdm-tab {\n  height: 32px !important;\n  min-height: 32px !important;\n}\n\n.checkbox-highlight {\n  box-shadow: inset 0px 0px 1px 1px orange;\n}\n\n.procos-tab-panel {\n  min-height: 20px !important;\n}\n\n.tabs-padding {\n  padding: 7px 15px 7px 15px;\n}\n\n.tab-icon {\n  margin-right: 5px;\n}\n\n.failed-rule {\n  max-height: 100px;\n  .p-5px();\n}\n\n.autocomplete {\n  padding: 3px !important;\n}\n\n.contents {\n  display: flex;\n  justify-content: space-between;\n  height: 100%;\n}\n\n.leftBar {\n  border-right: 1px solid rgba(224, 224, 224, 1);\n  width: 20%;\n  height: 100% !important;\n  overflow: hidden;\n\n  .MuiAutocomplete-inputRoot {\n    border-radius: 0;\n  }\n\n  .defaultExpandIcon {\n    color: #0062a1;\n  }\n\n  .defaultCollapseIcon {\n    color: #0078ce;\n  }\n\n  .defaultEndIcon {\n    color: @philips-gray;\n  }\n\n  .featuresTree {\n    height: 80%;\n    max-width: 100%;\n    overflow-y: auto;\n  }\n\n  .treeSearchBar {\n    .innerTextField > div {\n      // To remove unwanted padding to the search bar\n      padding-top: 0% !important;\n      padding-bottom: 0% !important;\n    }\n\n    .innerTextField > div > div > button {\n      // To make the clear icon visible\n      visibility: visible !important;\n    }\n  }\n}\n\n.rightBar {\n  width: 100% !important;\n  height: 95% !important;\n  display: flex;\n  overflow: hidden;\n  flex-direction: column;\n  justify-content: space-between;\n  padding-right: 1%;\n  padding-left: 0.5%;\n}\n\n.properties-div {\n  height: 80% !important;\n  .refresh-button {\n    path {\n      font-size: 18px !important;\n    }\n  }\n}\n\n.inputFieldset {\n  box-sizing: border-box;\n  border-radius: 4px;\n  border-width: 1.5px;\n  border-color: rgba(0, 0, 0, 0.2);\n  border-style: solid;\n  width: 100%;\n  padding-bottom: 4px !important;\n  padding-left: 0.8rem !important;\n  margin-top: 10px !important;\n\n  &:hover:not(:focus):not(:focus-within) {\n    border-color: rgba(0, 0, 0, 0.87);\n  }\n\n  &:focus-within {\n    border-color: #1173a3;\n  }\n\n  & > legend.inputLegend {\n    color: rgba(0, 0, 0, 0.6);\n    word-break: break-all;\n  }\n\n  &:focus-within > legend.inputLegend {\n    color: @philips-blue;\n  }\n\n  &:hover:not(:focus):not(:focus-within) > legend.inputLegend {\n    color: rgba(0, 0, 0, 0.87);\n  }\n}\n\n.properties-pane-title {\n  padding-bottom: 1px !important;\n}\n\n.flow {\n  overflow: auto;\n  height: 92%;\n}\n\n.action-button {\n  display: flex;\n  height: 8%;\n  padding: 1px;\n}\n\n.toggle-switch {\n  padding-left: 1%;\n  padding-top: 0px !important;\n}\n\n.switch-field {\n  padding: 8px !important;\n  & .MuiSwitch-track {\n    border-radius: 11px;\n    &::before,\n    &::after {\n      position: absolute;\n      top: 40%;\n      transform: translateY(-50%);\n      width: 16px;\n      height: 16px;\n    }\n    &::before {\n      content: 'Y';\n      left: 17px;\n      color: white;\n    }\n    &::after {\n      content: 'N';\n      right: 8px;\n      color: white;\n    }\n  }\n  & .MuiSwitch-thumb {\n    box-shadow: none;\n    width: 16px;\n    height: 16px;\n    margin: 2px;\n  }\n}\n\n.warning-icon {\n  font-size: 1.8rem !important;\n  color: @philips-orange;\n}\n\n.defaultIcon {\n  color: hsl(51, 79%, 25%);\n  border: 2px solid hsl(51, 59%, 55%);\n  background-color: hsl(51, 89%, 95%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 56px;\n  &.empty {\n    border: none;\n    background-color: transparent;\n  }\n}\n\n.MuiDataGrid-columnSeparator--resizable {\n  cursor: e-resize !important;\n}\n\n.css-15l8jjv .MuiDataGrid-columnSeparator--resizable {\n  cursor: e-resize;\n  touch-action: none;\n}\n\n.status-inactive {\n  background: grey;\n  color: white;\n  text-align: center;\n}\n\n.status-active {\n  background: forestgreen;\n  color: white;\n  text-align: center;\n}\n\n.inActiveWarningMessage {\n  margin-left: 0.5em;\n  .warningMessage {\n    .warningIcon();\n    .colFlex();\n    line-height: 1.2;\n    color: @philips-orange;\n    font-size: 1rem !important;\n  }\n  .warningSize {\n    height: 100% !important;\n    width: 2em !important;\n    color: @philips-orange;\n  }\n  .warningIcon {\n    color: @philips-orange;\n    font-size: 2rem !important;\n  }\n}\n\n.navbar {\n  font-size: 12px !important;\n  line-height: 3 !important;\n}\n.navbar a {\n  color: grey;\n  text-decoration: none !important;\n}\n.navbar a.active {\n  color: @philips-blue;\n  border-bottom: 2px solid @philips-blue !important;\n  text-decoration: none !important;\n}\n\n.headerLogo {\n  cursor: pointer !important;\n}\n\n.cellWithValueAsNo {\n  background-color: pink !important;\n  color: red !important;\n}\n\n.active-menu {\n  width: 10rem;\n}\n\n.fail-effectivity {\n  height: 150px;\n  overflow-y: auto;\n}\n\n.icon-font-size {\n  font-size: 2rem !important;\n  margin-right: 5px !important;\n}\n\n.properties-content {\n  height: 100%;\n}\n\n.header-action {\n  display: flex;\n  justify-content: flex-end;\n}\n.disabled {\n  pointer-events: none;\n  opacity: 0.5;\n}\n.enabled {\n  pointer-events: auto;\n  opacity: 1;\n}\n\n.toast-content-default {\n  background-color: white;\n}\n\n.toast-content-success {\n  background-color: @philips-green;\n  color: black;\n}\n\n.toast-content-warning {\n  background-color: @philips-orange;\n  color: black;\n}\n\n.toast-content-error {\n  background-color: @philips-red;\n  color: black;\n}\n\n.wi-toast-content-success {\n  background-color: @philips-green;\n  color: black;\n}\n\n.effectivity-toast-content-success {\n  margin-top: 90px;\n  background-color: @philips-green;\n  color: black;\n}\n\n.effectivity-toast-content-error {\n  margin-top: 90px;\n  background-color: @philips-red;\n  color: black;\n}\n\n.absolute-right {\n  position: absolute !important;\n  right: 0;\n}\n\n.appTabs-border {\n  border-bottom: solid 1px rgba(0, 0, 0, 0.12);\n}\n\n.link {\n  .cursor-pointer();\n  text-decoration: underline !important;\n  color: blue !important;\n}\n\n.data-table-container {\n  /* Add this class to the container */\n  display: flex;\n  flex-direction: column;\n  flex: 1; /* Allow container to grow */\n  overflow: auto; /* Allow scrolling if content overflows */\n  width: 100%;\n}\n\n.data-table-container .data-table {\n  flex-grow: 1; /* Allow DataTable to grow */\n}\n\n.data-table-container .pagination-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 50px; /* Ensure pagination is visible */\n  padding: 1rem;\n  overflow: auto;\n}\n\n.data-table-container .pagination-container .MuiPagination-root {\n  width: 100%;\n}\n\n.manipulation-dialog {\n  width: 100%;\n  min-height: 50%;\n  height: 70%;\n  max-height: 70%;\n  max-width: 100%;\n  margin-top: 10rem;\n  z-index: 99 !important;\n}\n\n.manipulation-dialog .formActionButtons {\n  text-align: right;\n}\n\n.tabsAndActionPanel {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.searchIconForColumn {\n  .rowFlex();\n  .align-center();\n}\n\n.h-3-5 {\n  height: 3.5%;\n}\n\n.headerLogoButton {\n  background: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.pdmHistoryDialogStyle {\n  .paper {\n    width: 85% !important;\n    height: 110vh !important;\n    max-width: 100% !important;\n  }\n\n  .title {\n    display: flex; /* keeps first span at start in normal flow */\n    align-items: center; /* vertical centering if there's height */\n    justify-content: start;\n    gap: 4px;\n    width: 100%;\n    position: relative;\n  }\n\n  .start {\n    /* stays at the start in normal flow */\n    width: max-content;\n    min-width: max-content;\n    text-align: start;\n  }\n\n  .center {\n    width: max-content;\n    text-align: start;\n    display: flex;\n    justify-content: start;\n    text-overflow: clip;\n  }\n\n  .close {\n    align-items: center;\n    justify-content: center;\n    margin-left: auto;\n    height: 100%;\n    width: max-content;\n    min-width: max-content;\n    color: white;\n  }\n  .dialogContent {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 20px !important;\n    .MuiDataGrid-root {\n      min-height: 90% !important;\n    }\n    .manage-tab-pagination {\n      margin-top: 0 !important;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n}\n\n.historyFilterPanel {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  width: max-content !important;\n  .historyFilterContent {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n    flex-wrap: wrap;\n    flex-direction: row;\n    width: max-content !important;\n    .historyFilterRow {\n      display: flex;\n      gap: 16px;\n      flex-direction: row;\n      align-items: center;\n      width: max-content !important;\n      .historyFilterFormControl {\n        min-width: 145px;\n      }\n    }\n  }\n}\n\n.color-red {\n  color: red !important;\n}\n\n.history-button {\n  path {\n    font-size: 18px !important;\n  }\n  span {\n    font-size: 12px !important;\n  }\n}\n\n.delete-button {\n  .text-capitalize();\n  color: red;\n}\n\n.autocomplete-value-mismatch {\n  .MuiOutlinedInput-notchedOutline {\n    border-color: @philips-red !important;\n  }\n\n  .MuiOutlinedInput-input {\n    color: @philips-red !important;\n    -webkit-text-fill-color: @philips-red !important;\n  }\n\n  .Mui-disabled {\n    .MuiOutlinedInput-notchedOutline {\n      border-color: @philips-red !important;\n    }\n\n    .MuiOutlinedInput-input {\n      -webkit-text-fill-color: @philips-red !important;\n    }\n  }\n\n  .MuiInputLabel-root.Mui-disabled {\n    color: @philips-red !important;\n  }\n}\n","html,\nbody,\n#root {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  font-size: small;\n}\nhtml#root,\nbody#root,\n#root#root {\n  overflow: hidden;\n}\nbody {\n  font-family: 'NeueFrutigerWorldW02-Regular', sans-serif !important;\n  overflow: hidden;\n}\nbody * {\n  font-family: 'NeueFrutigerWorldW02-Regular', sans-serif !important;\n}\n* {\n  box-sizing: border-box;\n}\n@font-face {\n  font-family: 'NeueFrutigerWorldW02-Regular';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url('../public/NeueFrutigerWorldW02-Regular.woff2');\n}\n.customToolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: min-content !important;\n}\n.columnsPanelTrigger {\n  min-height: min-content !important;\n  min-width: min-content !important;\n}\n.filterPanelTrigger {\n  min-height: min-content !important;\n  min-width: min-content !important;\n}\n.category {\n  height: 80vh;\n  display: flex;\n  flex-direction: column;\n  padding: 2px;\n  overflow-y: auto;\n}\n.category .multi-numeric-icon {\n  color: #ffa300;\n}\n.category .header-section {\n  margin-left: 7px;\n  width: 99%;\n  box-sizing: border-box;\n  margin-bottom: 2px;\n}\n.category .header-section .section-view {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n.category .header-section .section-view .edit-view button {\n  text-transform: capitalize;\n}\n.category .header-section .category-header-section {\n  display: flex;\n  flex-direction: row;\n  overflow: hidden;\n  width: 100%;\n  background: #f2f4f7;\n  border-radius: 1px 1px 0px 0px;\n  border: 1px solid #dde1e9;\n  height: 35px;\n  max-height: 35px;\n  font-size: 12px !important;\n  align-items: center;\n}\n.category .header-section .category-header-section .breacrum-header-section {\n  width: 50%;\n  display: flex;\n  align-items: center;\n}\n.category .header-section .category-header-section .breacrum-header-section .css-1v5z4dq-MuiPaper-root-MuiCard-root {\n  border: 0px;\n}\n.category .header-section .category-header-section .breacrum-header-section button {\n  padding-top: 0px;\n  padding-bottom: 0px;\n  width: 100px;\n  margin-right: 5px;\n  margin-left: 0px;\n  height: 33px;\n  border-radius: 2px;\n  text-transform: capitalize;\n}\n.category .header-section .category-header-section .breacrum-header-section .MuiPaper-root.MuiCard-root {\n  border: 0px;\n}\n.category .header-section .category-header-section .breacrum-header-section nav {\n  white-space: nowrap;\n}\n.category .categories-container {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 20px;\n  margin-left: 7px;\n  width: 99%;\n  flex: 1;\n  min-height: 369px;\n}\n.category .categories-container .categories-panel {\n  width: 560px;\n  display: flex;\n  flex-direction: column;\n}\n.category .categories-container .categories-panel h3 {\n  margin-bottom: 8px;\n}\n.category .categories-container .categories-panel .categories-list {\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1;\n  max-height: calc(70vh - 150px);\n}\n.category .categories-container .droppable-zones {\n  display: flex;\n  gap: 20px;\n  flex: 1;\n}\n.category .categories-container .droppable-zones > div {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n.category .breadcrumb-card-section nav {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.category .breadcrumb-card-section nav a {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  transition: color 0.2s ease;\n  font-size: 14px;\n  padding: 4px 6px;\n  border-radius: 4px;\n  background-color: #f2f4f7;\n}\n.category .breadcrumb-card-section nav a.active {\n  color: black;\n  font-weight: 500;\n}\n.category .breadcrumb-card-section nav a.not-active {\n  color: #666;\n}\n.category .breadcrumb-card-section nav a.not-active:hover {\n  color: #333;\n  background-color: rgba(0, 0, 0, 0.04);\n}\n.category .breadcrumb-card-section nav .MuiSvgIcon-root {\n  color: #999;\n  margin: 0 8px;\n}\n.category .category-content {\n  display: flex;\n  flex: 1;\n  height: calc(100% - 100px);\n  position: relative;\n}\n.category .left-pane,\n.category .middle-pane,\n.category .right-pane {\n  position: relative;\n}\n.category .left-pane {\n  --pane-width: 30%;\n  width: var(--pane-width);\n  min-width: 200px;\n  height: 100%;\n  border: 1px solid #eee;\n  border-radius: 4px;\n  margin-left: 8px;\n}\n.category .middle-pane {\n  --pane-width: 35%;\n  width: var(--pane-width);\n  min-width: 200px;\n  height: 96%;\n}\n.category .right-pane {\n  --pane-width: 35%;\n  width: var(--pane-width);\n  min-width: 200px;\n  height: 96%;\n}\n.category .resize-hor {\n  resize: horizontal;\n}\n.category .disabled-view {\n  opacity: 0.6;\n  pointer-events: none;\n}\n.category .assigned-section-header,\n.category .unassingned-section-header {\n  border-bottom: 2px solid #eee;\n  padding-left: 4%;\n  font-weight: bold;\n}\n.category-item {\n  position: relative;\n}\n.category-item.over:not(.invalid) {\n  border: 2px solid #1474a4;\n}\n.category-item.invalid {\n  border: 2px solid #ef4444;\n  outline: none;\n}\n.category-item.hover:not(.invalid):not(.over) > div:first-child {\n  outline: 2px dashed #1474a4;\n}\n.category-item .category-row {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n}\n.category-item .category-content {\n  width: 100%;\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.category-item .category-content.selected {\n  background: transparent;\n}\n.category-item .category-content.selected .feature-name,\n.category-item .category-content.selected .action-button {\n  color: #1474a4;\n  font-weight: 500;\n}\n.category-item .category-content.selected .drag-handle .feature-icon .category-icon {\n  color: #1474a4 !important;\n}\n.category-item .category-content.selected .drag-handle .feature-icon .category-icon.multi-numeric-icon {\n  color: #ffa300 !important;\n}\n.category-item .category-content.parent-selected .feature-name {\n  color: #1474a4;\n  font-weight: 500;\n}\n.category-item .category-content.parent-selected .drag-handle .feature-icon .category-icon {\n  color: #1474a4 !important;\n}\n.category-item .category-content.parent-selected .drag-handle .feature-icon .category-icon.multi-numeric-icon {\n  color: #ffa300 !important;\n}\n.category-item .category-title {\n  display: flex;\n  align-items: center;\n  flex: 1;\n}\n.category-item .drag-handle {\n  display: flex;\n  align-items: center;\n  flex: 1;\n}\n.category-item .feature-name {\n  margin-left: 6px;\n}\n.category-item .category-actions-wrapper {\n  display: flex;\n  align-items: center;\n  margin-left: 8px;\n}\n.category-item .subcategories {\n  margin-left: 20px;\n}\n.droppable-zone {\n  flex: 1;\n  min-width: 300px;\n  display: flex;\n  flex-direction: column;\n  height: 98%;\n}\n.droppable-zone h3 {\n  margin-bottom: 8px;\n}\n.droppable-zone h3.highlighted {\n  color: #1474a4;\n}\n.droppable-zone .drop-area {\n  padding: 15px;\n  background: #fff;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow-y: auto;\n  z-index: 1;\n}\n.droppable-zone .drop-area .items-container {\n  flex: 1;\n  overflow-y: auto;\n}\n.droppable-zone .drop-area.over:not(.invalid),\n.droppable-zone .drop-area[data-highlight='true']:not([data-invalid='true']) {\n  border: 2px solid #1474a4 !important;\n  border-style: solid !important;\n  background: transparent;\n  z-index: 2;\n  box-shadow: 0 0 0 1px rgba(20, 116, 164, 0.3);\n}\n.droppable-zone .drop-area.invalid,\n.droppable-zone .drop-area[data-invalid='true'] {\n  border: 2px solid #ef4444 !important;\n  border-style: solid !important;\n  background: transparent;\n  z-index: 3;\n  box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.3);\n}\n.droppable-zone .drop-area .empty-message {\n  color: #666;\n  font-style: italic;\n}\n.draggable-sortable-item.dragging {\n  cursor: grabbing;\n  opacity: 0.4;\n  background-color: #f0f6ff !important;\n  border: 1px dashed #ccc;\n  box-shadow: none;\n  z-index: 1000 !important;\n  pointer-events: none;\n}\n.draggable-sortable-item.sortable {\n  border-radius: 4px;\n  cursor: grab;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n.draggable-sortable-item.sortable .item-content {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.5;\n  letter-spacing: 0.00938em;\n}\n.draggable-sortable-item.sortable .item-content .item-description {\n  margin-right: 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.draggable-sortable-item.sortable .item-content .item-code {\n  flex-shrink: 0;\n  white-space: nowrap;\n  color: #666;\n}\n.draggable-sortable-item.sortable .item-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.draggable-sortable-item.sortable .item-actions .drag-handle {\n  color: #666;\n  font-size: 14px;\n}\n.draggable-sortable-item.draggable {\n  border-radius: 4px;\n  cursor: grab;\n  display: flex;\n  align-items: center;\n}\n.draggable-sortable-item.draggable .item-content {\n  margin-left: 8px;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.5;\n  letter-spacing: 0.00938em;\n}\n.draggable-sortable-item.draggable .item-content .item-description {\n  margin-right: 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.draggable-sortable-item.draggable .item-content .item-code {\n  flex-shrink: 0;\n  white-space: nowrap;\n  color: #666;\n}\n.draggable-sortable-item.disabled {\n  opacity: 0.6;\n  cursor: default;\n  pointer-events: none;\n  color: #888;\n}\n.draggable-sortable-item.disabled.sortable {\n  background: #f7f9ff;\n}\n.draggable-sortable-item.disabled.draggable {\n  background: #f5f5f5;\n}\n.common-dialog-style .MuiPaper-root .MuiDialogTitle-root {\n  background: #1474a4;\n  color: #fff;\n  padding: 7px;\n  padding-left: 23px;\n  cursor: move;\n}\n.common-dialog-style .MuiPaper-root .MuiBox-root {\n  width: 100%;\n}\n.add-category-dialog .MuiPaper-root {\n  width: 80%;\n}\n.drag-preview {\n  padding: 2px 2px;\n  border-radius: 4px;\n  background: #1474a4;\n  color: #ffffff;\n  font-weight: 500;\n  font-size: 12px;\n  pointer-events: none;\n  max-width: 300px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.drag-preview .item-code {\n  opacity: 0.8;\n  font-size: 12px;\n}\n[data-dnd-overlay] {\n  z-index: 9999 !important;\n}\n.drag-overlay-content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n}\n.drag-overlay-content .item-name {\n  font-weight: 500;\n}\n.drag-overlay-content .item-code {\n  color: #666;\n}\n.auto-complete-searchbar {\n  margin-top: 16px;\n  display: flex;\n}\n.auto-complete-search-input {\n  flex-basis: 90%;\n}\n.auto-complete-search-input .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {\n  border-radius: 4px 0px 0px 4px !important;\n}\n.auto-complete-search-button {\n  background: white;\n  border-radius: 0px 4px 4px 0px !important;\n  border: solid 2px #e2e2e2 !important;\n  border-left: none !important;\n}\n.auto-complete-search-icon {\n  font-size: 25px !important;\n  color: #1474a4 !important;\n}\n.css-xnywni-MuiFormLabel-root-MuiInputLabel-root {\n  top: 20px !important;\n  position: relative !important;\n}\n.css-196bwzp-MuiPaper-root-MuiCard-root {\n  background-color: #f2f4f7 !important;\n}\n.css-1umw9bq-MuiSvgIcon-root {\n  width: 16px !important;\n  height: 0.9em !important;\n}\n.header-large-icon {\n  font-size: 1.7rem !important;\n  line-height: 1;\n}\n.icon-with-label {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-right: 24px;\n}\n.edit-view {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n}\n.icon-helper-text {\n  font-size: 0.95rem;\n  color: #1474a4;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n}\n.css-nykz7-MuiTreeItem-content {\n  padding: 4px 8px 0px 0px !important;\n  gap: 0px !important;\n}\n.css-nykz7-MuiTreeItem-content.Mui-selected {\n  background-color: revert !important;\n}\n.category-wrapper {\n  padding-left: 0;\n}\n.category-wrapper[data-section-depth] {\n  padding-left: calc(var(--category-depth, 0) * 20px);\n}\n.css-fojsl4-MuiTreeItem-content {\n  gap: 0px !important;\n}\n.small-badge .MuiBadge-badge {\n  font-size: 0.65rem;\n  height: 16px;\n  min-width: 16px;\n  padding: 0 4px;\n}\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n::-webkit-scrollbar-thumb {\n  background: #5a9dbf;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: #5a9dbf;\n}\n.footer {\n  border-top: 0.1rem solid rgba(0, 0, 0, 0.12);\n  color: black;\n  margin-right: 1px;\n  display: flex;\n  flex-direction: row;\n}\n.footer.root {\n  display: flex;\n  width: 100% !important;\n  font-size: 12px;\n}\n.footer .env {\n  margin-right: 1px;\n  padding-right: 1px;\n}\n.footer .termsAndCondition {\n  display: flex;\n  flex-direction: row;\n  margin-right: 1px;\n}\n.footer.bg-gray {\n  background-color: #eeeeee;\n}\n.footer.bg-green {\n  background-color: #93c47d;\n}\n.footer.bg-orange {\n  background-color: #f7d368;\n}\n.footer.bg-yellow {\n  background-color: #f3f66b;\n}\n.termsAndCondition-dialog .paperClass {\n  width: 45%;\n  height: 60vh;\n}\n.d-flex {\n  display: flex;\n}\n.d-inline-flex {\n  display: inline-flex;\n}\n.d-block {\n  display: block;\n}\n.d-inline-block {\n  display: inline-block;\n}\n.d-inline {\n  display: inline;\n}\n.flex-row {\n  flex-direction: row;\n}\n.flex-column {\n  flex-direction: column;\n}\n.flex-nowrap {\n  flex-wrap: nowrap;\n}\n.squareSize {\n  width: 100%;\n  height: 100%;\n}\n.w-0 {\n  width: 0%;\n}\n.w-25 {\n  width: 25%;\n}\n.w-50 {\n  width: 50%;\n}\n.w-100 {\n  width: 100% !important;\n}\n.w-auto {\n  width: auto;\n}\n.w-25ch {\n  width: '25ch';\n}\n.w-10 {\n  width: 10%;\n}\n.w-20 {\n  width: 20%;\n}\n.w-40 {\n  width: 40%;\n}\n.w-45 {\n  width: 45%;\n}\n.w-90 {\n  width: 90%;\n}\n.mw-0 {\n  max-width: 0%;\n}\n.mw-25 {\n  max-width: 25%;\n}\n.mw-50 {\n  max-width: 50%;\n}\n.mw-100 {\n  max-width: 100%;\n}\n.mw-10 {\n  max-width: 10%;\n}\n.h-0 {\n  height: 0%;\n}\n.h-25 {\n  height: 25%;\n}\n.h-50 {\n  height: 50%;\n}\n.h-100 {\n  height: 100% !important;\n}\n.h-90vh {\n  height: 90vh !important;\n}\n.h-auto {\n  height: auto;\n}\n.h-inherit {\n  height: inherit;\n}\n.m-0 {\n  margin: 0;\n}\n.mt-0 {\n  margin-top: 0;\n}\n.mt-1em {\n  margin-top: 1em !important;\n}\n.mr-0 {\n  margin-right: 0;\n}\n.mr-5px {\n  margin-right: 5px !important;\n}\n.mb-0 {\n  margin-bottom: 0;\n}\n.mb-05em {\n  margin-bottom: 0.5em !important;\n}\n.ml-0 {\n  margin-left: 0;\n}\n.ml-1 {\n  margin-left: 1% !important;\n}\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n.p-0 {\n  padding: 0px !important;\n}\n.p-1 {\n  padding: 1px !important;\n}\n.p-3px {\n  padding: 3px !important;\n}\n.p-5px {\n  padding: 5px;\n}\n.p-10px {\n  padding: 10px !important;\n}\n.p-20px {\n  padding: 20px;\n}\n.p-15px {\n  padding: 15px;\n}\n.p-1rem {\n  padding: 1rem;\n}\n.pt-0 {\n  padding-top: 0 !important;\n}\n.pt-1 {\n  padding-top: 1em !important;\n}\n.pr-1 {\n  padding-right: 1em !important;\n}\n.pl-0 {\n  padding-left: 0;\n}\n.pr-0 {\n  padding-right: 0;\n}\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n.pb-1 {\n  padding-bottom: 1em !important;\n}\n.float-right {\n  float: right;\n}\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n.px-0 {\n  padding-right: 0;\n  padding-left: 0;\n}\n.overflow-auto {\n  overflow: auto;\n}\n.overflowX-auto {\n  overflow-x: auto;\n}\n.overflowY-auto {\n  overflow-y: auto;\n}\n.text-left {\n  text-align: left !important;\n}\n.text-right {\n  text-align: right !important;\n}\n.text-center {\n  text-align: center;\n}\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n.text-bold {\n  font-weight: bold;\n}\n.ws-nowrap {\n  white-space: nowrap !important;\n}\n.vertical-middle {\n  vertical-align: middle;\n}\n.align-top {\n  align-items: flex-start;\n}\n.align-center {\n  align-items: center;\n}\n.alignself-center {\n  align-self: center;\n}\n.alignself-start {\n  align-self: self-start;\n}\n.justify-left {\n  justify-content: left !important;\n}\n.justify-center {\n  justify-content: center;\n}\n.justify-right {\n  justify-content: right;\n}\n.justify-end {\n  justify-content: flex-end;\n}\n.justify-spacebetween {\n  justify-content: space-between;\n}\n.justify-start {\n  justify-content: flex-start;\n}\n.cursor-move {\n  cursor: move;\n}\n.warning {\n  color: #f7d368 !important;\n}\n.bottomUnset {\n  border-bottom: unset;\n}\n.rowFlex {\n  display: flex;\n  flex-direction: row;\n}\n.colFlex {\n  display: flex;\n  flex-direction: column;\n}\n.flex-start {\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n.cursor-pointer {\n  cursor: pointer;\n}\n.cursor-default {\n  cursor: default !important;\n}\n.position-absolute {\n  position: absolute;\n}\n.overflow-hidden {\n  overflow: hidden;\n}\n.textWidth50 {\n  width: 50%;\n  display: inline-block;\n}\n.overflowY-hidden {\n  overflow-y: hidden;\n}\n.overflow-ellipsis {\n  text-overflow: ellipsis;\n}\n.overflowWrap-anywhere {\n  overflow-wrap: anywhere;\n}\n.zindex-100 {\n  z-index: 100;\n}\n.zindex-2000 {\n  z-index: 2000;\n}\n.border-radius-0 {\n  border-radius: 0 !important;\n}\n.bg-philips-blue {\n  background-color: #1474a4;\n}\n.bg-lightgray {\n  background-color: lightgray;\n}\n.b-0 {\n  border: 0;\n}\n.philipsBlue {\n  color: #1474a4 !important;\n}\n.PhilipsRed {\n  color: red;\n}\n.zoom80 {\n  zoom: 80%;\n}\n.appRouter.root {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n}\n.appRouter .secondaryHeader {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 38px;\n}\n.appRouter .secondaryHeader .headername {\n  padding: 10px !important;\n  display: flex;\n  color: #1474a4;\n  font-weight: bold;\n  font-size: 14px;\n}\n.appRouter .secondaryHeaderTabs {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: auto;\n}\n.appRouter .appRouterContent {\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  width: -webkit-fill-available;\n}\n.appRouter .divider {\n  width: 100%;\n}\n.termsAndConditionStyle {\n  display: flex;\n  flex-direction: row;\n  margin-right: 1px;\n}\n.termsAndConditionStyle .title {\n  cursor: pointer;\n  text-decoration: underline;\n  color: blue;\n}\n.headerStyle.root {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n.headerStyle .toolbar {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  padding: 0 10px;\n  min-height: 3rem;\n  padding-top: 0.3rem !important;\n  padding-bottom: 0.3rem !important;\n}\n.headerStyle .toolbarSection {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n}\n.headerStyle .tooltip {\n  margin: 2;\n}\n.headerStyle .button-icon {\n  cursor: pointer;\n  color: #ffffff;\n}\n.userPanelIconButton {\n  cursor: pointer;\n  color: white !important;\n  padding: 5px !important;\n}\n.userPanelIconButton .userProfileIcon {\n  height: 2rem;\n  width: 2rem;\n}\n.popperStyle.arrow {\n  width: 3em;\n  height: 3em;\n}\n.popperStyle::before {\n  content: '';\n  margin: auto;\n  display: block;\n  width: 0%;\n  border-style: solid;\n  border-width: 0px 1em 1em;\n  border-color: transparent transparent #ffffff;\n  margin-top: -0.4rem;\n}\n.middle-container {\n  overflow: auto;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 100% !important;\n  padding: 0.5em 1em;\n}\n.middle-container .mainHeader {\n  margin-top: 0em;\n  margin-bottom: 0.2em;\n}\n.common-dialog-paper {\n  width: 550px !important;\n  min-width: 550px !important;\n}\n.common-dialog-style .header {\n  background-color: #1474a4;\n  font-size: 1.2rem;\n  padding: 0.5rem;\n  border-bottom: 0.1rem solid rgba(0, 0, 0, 0.12);\n  color: white;\n  text-align: left !important;\n}\n.common-dialog-style .paper {\n  height: 60vh;\n}\n.common-dialog-style .dialogContent {\n  padding-top: 4vh !important;\n}\n.common-dialog-style .closeIcon {\n  position: absolute;\n  right: 0px;\n  top: 0px;\n  color: white;\n}\n.landing-Page-body {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.header4 {\n  font-size: large;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-left: 10px;\n}\n.catalog-Container {\n  width: 376px;\n  height: 100px;\n  padding: 5px;\n}\n.catalog-cardLayout {\n  display: flex;\n  padding: 10px !important;\n}\n.catalog-image {\n  height: 80px;\n  width: 80px;\n  margin-left: 5px;\n  margin-top: 5px;\n}\n.catalog-info {\n  flex-basis: 90%;\n  padding: 5px;\n}\n.catalog-productDescription {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  width: 34ch;\n}\n.noData-label {\n  width: 50%;\n  margin-left: 45%;\n  padding-top: 15%;\n}\n.catalog-icon {\n  display: flex;\n  flex-basis: 10%;\n  padding: 5px;\n  cursor: pointer;\n}\n.catalog-create {\n  background-color: #1474a4 !important;\n}\n.productCatalogCardHeader {\n  color: #1474a4;\n  font-weight: bold;\n}\n.list-Section {\n  display: block;\n  height: calc(90% - 8.6rem);\n  padding: 0px 10px 10px 10px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.list-Section ul > div {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n}\n.list-Section-Tab {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.list-Items {\n  padding-top: 0px !important;\n}\n.list-Section::-webkit-scrollbar {\n  height: 10px;\n}\n.list-ItemsContainer {\n  margin-left: 0px !important;\n  padding: 5px;\n}\n.recordsPerPage {\n  height: 30px;\n  margin-right: 15px;\n}\n.recordsPerPage > div {\n  padding: 8.5px !important;\n}\n.refresh-button {\n  min-height: min-content !important;\n  min-width: min-content !important;\n  padding: 6px 8px;\n  position: relative !important;\n}\n.procos-export-button {\n  margin-left: 30px !important;\n  text-transform: none !important;\n}\n.pcs-export-button {\n  margin-left: 40px !important;\n  text-transform: none !important;\n}\n.refresh-button > span {\n  padding-right: 2px;\n  margin: 0px !important;\n}\n.export-button > span {\n  margin: 4px !important;\n}\n.recordsChange-conatiner {\n  display: flex;\n  flex-direction: row-reverse;\n  margin-right: 10px;\n  align-items: center;\n}\n.recordsChange-conatiner .form-control {\n  width: 5.5rem;\n  margin-left: 10px;\n}\n.Records {\n  display: flex;\n  justify-content: flex-end;\n}\n.home-icon {\n  color: #1474a4 !important;\n  width: 100%;\n  padding: 3px !important;\n  margin: 0px !important;\n}\n.action-icon {\n  color: #1474a4 !important;\n  margin: 0px !important;\n  padding: 2px !important;\n}\n.action-icon-disabled {\n  color: #eeeeee !important;\n  margin: 0px !important;\n  padding: 3px !important;\n}\n.form-text {\n  color: red !important;\n}\n.breadCrumb.root {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  padding: 10px;\n}\n.breadCrumb .item {\n  color: #1474a4 !important;\n  text-overflow: ellipsis;\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  cursor: pointer;\n  text-decoration: none;\n  font-size: 1rem;\n  font-weight: bold;\n}\n.breadCrumb .activeItem {\n  font-weight: bold;\n}\n.search-bar.MuiAutocomplete-root {\n  width: 20em !important;\n  position: relative;\n  bottom: 3px;\n  right: 20px;\n  padding-top: 0.3rem;\n}\n.search-bar.MuiAutocomplete-root .search-inner-text > div {\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n  margin-left: 0.7vw;\n}\n.search-bar.MuiAutocomplete-root .search-inner-text > div > div > button {\n  visibility: visible !important;\n}\n.search-bar.MuiAutocomplete-root .search-inner-text > div > div > svg {\n  position: absolute !important;\n  top: 1.1vh !important;\n  left: 0.2vw !important;\n}\n.unsupported-browser {\n  display: inline-block;\n  text-align: center;\n  width: 45%;\n  height: 90%;\n  margin-left: auto;\n  margin-right: auto;\n}\n.unsupported-browser .message {\n  text-align: left;\n  padding-top: 5px !important;\n}\n.unsupported-browser .unsupported-browser-image {\n  height: 50;\n  width: 40;\n}\n.unsupported-browser .versionSupported {\n  z-index: 150000 !important;\n  padding: 10px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n.unsupported-browser .versionSupported .browserBox {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0 2%;\n  justify-content: space-between;\n}\n.unsupported-browser .versionSupported .browserBox img {\n  height: 35px;\n  width: 35px;\n}\n.unsupported-browser .versionSupported .browserBox .browserDetails {\n  display: flex;\n  flex-direction: column;\n}\n.activeIcon {\n  color: #eeeeee !important;\n  background-color: #1474a4 !important;\n}\n.languageContainer {\n  font-size: 1rem !important;\n  padding: 0px !important;\n  vertical-align: middle !important;\n  align-items: center !important;\n  border-radius: 0 !important;\n  width: max-content;\n}\n.data-table {\n  height: calc(90% - 8.6rem);\n  padding-bottom: 10px;\n  width: 60%;\n}\n.features-table {\n  height: calc(90% - 8.6rem);\n  width: 100%;\n}\n.features-table .recordPicker {\n  position: relative;\n  bottom: 3px;\n  padding-top: 0.3rem;\n}\n.alert-dialog {\n  display: inline-block;\n  width: 45%;\n  height: 90%;\n  margin-left: auto;\n  margin-right: auto;\n  min-width: 30%;\n}\n.alert-dialog .MuiDialog-container .MuiPaper-root {\n  min-width: 40%;\n}\n.autocomplete-div {\n  margin-top: 0.3%;\n  flex-basis: 35%;\n}\n.tab-Panel {\n  height: 20px !important;\n  min-height: 20px !important;\n}\n.loading-message {\n  display: block;\n  text-align: center;\n  background: white;\n  padding: 50px;\n  box-shadow: 1px 1px 2px 1px grey;\n  border-radius: 3px;\n  width: 30%;\n  min-width: 30%;\n}\n.manage-tab-pagination {\n  align-items: center;\n  margin-top: 1rem;\n  height: 8rem;\n}\n.procos-pagination {\n  width: 60%;\n  align-items: center;\n}\n.procos-features-pagination {\n  width: 100%;\n  align-items: center;\n  padding-top: 1%;\n}\n.common-btn {\n  height: 2.5rem;\n  white-space: nowrap;\n}\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.tab-drawer-tabs {\n  text-transform: capitalize !important;\n  align-items: center;\n  justify-content: left !important;\n  text-align: left !important;\n  min-height: 30px;\n  padding: 7px;\n  color: rgba(0, 0, 0, 0.87) !important;\n}\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected.tab-drawer-tabs {\n  color: #1474a4 !important;\n  background: #c7e0f4 !important;\n  font-weight: 800 !important;\n}\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.pdm-tabs {\n  text-transform: capitalize !important;\n  align-items: center;\n  justify-content: center;\n  min-height: 30px;\n  padding: 7px;\n  color: rgba(0, 0, 0, 0.87) !important;\n}\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected.pdm-tabs {\n  color: #1474a4 !important;\n  font-weight: 800 !important;\n}\n.navigateTabLabel {\n  writing-mode: tb-rl;\n  height: inherit;\n  cursor: pointer;\n  font-size: 1.25rem;\n  white-space: nowrap;\n}\n.pinIcon {\n  font-size: 1.4rem !important;\n}\n.tabDrawerMini {\n  width: 4.5rem;\n  height: auto;\n  text-align: center;\n  background: #eeeeee;\n  z-index: 100;\n}\n.drawerOpen {\n  width: 200px;\n}\n.drawer-tab {\n  min-height: 500px !important;\n}\n.pdm-tab {\n  height: 32px !important;\n  min-height: 32px !important;\n}\n.checkbox-highlight {\n  box-shadow: inset 0px 0px 1px 1px orange;\n}\n.procos-tab-panel {\n  min-height: 20px !important;\n}\n.tabs-padding {\n  padding: 7px 15px 7px 15px;\n}\n.tab-icon {\n  margin-right: 5px;\n}\n.failed-rule {\n  max-height: 100px;\n  padding: 5px;\n}\n.autocomplete {\n  padding: 3px !important;\n}\n.contents {\n  display: flex;\n  justify-content: space-between;\n  height: 100%;\n}\n.leftBar {\n  border-right: 1px solid #e0e0e0;\n  width: 20%;\n  height: 100% !important;\n  overflow: hidden;\n}\n.leftBar .MuiAutocomplete-inputRoot {\n  border-radius: 0;\n}\n.leftBar .defaultExpandIcon {\n  color: #0062a1;\n}\n.leftBar .defaultCollapseIcon {\n  color: #0078ce;\n}\n.leftBar .defaultEndIcon {\n  color: #eeeeee;\n}\n.leftBar .featuresTree {\n  height: 80%;\n  max-width: 100%;\n  overflow-y: auto;\n}\n.leftBar .treeSearchBar .innerTextField > div {\n  padding-top: 0% !important;\n  padding-bottom: 0% !important;\n}\n.leftBar .treeSearchBar .innerTextField > div > div > button {\n  visibility: visible !important;\n}\n.rightBar {\n  width: 100% !important;\n  height: 95% !important;\n  display: flex;\n  overflow: hidden;\n  flex-direction: column;\n  justify-content: space-between;\n  padding-right: 1%;\n  padding-left: 0.5%;\n}\n.properties-div {\n  height: 80% !important;\n}\n.properties-div .refresh-button path {\n  font-size: 18px !important;\n}\n.inputFieldset {\n  box-sizing: border-box;\n  border-radius: 4px;\n  border-width: 1.5px;\n  border-color: rgba(0, 0, 0, 0.2);\n  border-style: solid;\n  width: 100%;\n  padding-bottom: 4px !important;\n  padding-left: 0.8rem !important;\n  margin-top: 10px !important;\n}\n.inputFieldset:hover:not(:focus):not(:focus-within) {\n  border-color: rgba(0, 0, 0, 0.87);\n}\n.inputFieldset:focus-within {\n  border-color: #1173a3;\n}\n.inputFieldset > legend.inputLegend {\n  color: rgba(0, 0, 0, 0.6);\n  word-break: break-all;\n}\n.inputFieldset:focus-within > legend.inputLegend {\n  color: #1474a4;\n}\n.inputFieldset:hover:not(:focus):not(:focus-within) > legend.inputLegend {\n  color: rgba(0, 0, 0, 0.87);\n}\n.properties-pane-title {\n  padding-bottom: 1px !important;\n}\n.flow {\n  overflow: auto;\n  height: 92%;\n}\n.action-button {\n  display: flex;\n  height: 8%;\n  padding: 1px;\n}\n.toggle-switch {\n  padding-left: 1%;\n  padding-top: 0px !important;\n}\n.switch-field {\n  padding: 8px !important;\n}\n.switch-field .MuiSwitch-track {\n  border-radius: 11px;\n}\n.switch-field .MuiSwitch-track::before,\n.switch-field .MuiSwitch-track::after {\n  position: absolute;\n  top: 40%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n}\n.switch-field .MuiSwitch-track::before {\n  content: 'Y';\n  left: 17px;\n  color: white;\n}\n.switch-field .MuiSwitch-track::after {\n  content: 'N';\n  right: 8px;\n  color: white;\n}\n.switch-field .MuiSwitch-thumb {\n  box-shadow: none;\n  width: 16px;\n  height: 16px;\n  margin: 2px;\n}\n.warning-icon {\n  font-size: 1.8rem !important;\n  color: #f7d368;\n}\n.defaultIcon {\n  color: hsl(51, 79%, 25%);\n  border: 2px solid hsl(51, 59%, 55%);\n  background-color: hsl(51, 89%, 95%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 56px;\n}\n.defaultIcon.empty {\n  border: none;\n  background-color: transparent;\n}\n.MuiDataGrid-columnSeparator--resizable {\n  cursor: e-resize !important;\n}\n.css-15l8jjv .MuiDataGrid-columnSeparator--resizable {\n  cursor: e-resize;\n  touch-action: none;\n}\n.status-inactive {\n  background: grey;\n  color: white;\n  text-align: center;\n}\n.status-active {\n  background: forestgreen;\n  color: white;\n  text-align: center;\n}\n.inActiveWarningMessage {\n  margin-left: 0.5em;\n}\n.inActiveWarningMessage .warningMessage {\n  font-size: 2rem !important;\n  display: flex;\n  flex-direction: column;\n  line-height: 1.2;\n  color: #f7d368;\n  font-size: 1rem !important;\n}\n.inActiveWarningMessage .warningSize {\n  height: 100% !important;\n  width: 2em !important;\n  color: #f7d368;\n}\n.inActiveWarningMessage .warningIcon {\n  color: #f7d368;\n  font-size: 2rem !important;\n}\n.navbar {\n  font-size: 12px !important;\n  line-height: 3 !important;\n}\n.navbar a {\n  color: grey;\n  text-decoration: none !important;\n}\n.navbar a.active {\n  color: #1474a4;\n  border-bottom: 2px solid #1474a4 !important;\n  text-decoration: none !important;\n}\n.headerLogo {\n  cursor: pointer !important;\n}\n.cellWithValueAsNo {\n  background-color: pink !important;\n  color: red !important;\n}\n.active-menu {\n  width: 10rem;\n}\n.fail-effectivity {\n  height: 150px;\n  overflow-y: auto;\n}\n.icon-font-size {\n  font-size: 2rem !important;\n  margin-right: 5px !important;\n}\n.properties-content {\n  height: 100%;\n}\n.header-action {\n  display: flex;\n  justify-content: flex-end;\n}\n.disabled {\n  pointer-events: none;\n  opacity: 0.5;\n}\n.enabled {\n  pointer-events: auto;\n  opacity: 1;\n}\n.toast-content-default {\n  background-color: white;\n}\n.toast-content-success {\n  background-color: #93c47d;\n  color: black;\n}\n.toast-content-warning {\n  background-color: #f7d368;\n  color: black;\n}\n.toast-content-error {\n  background-color: red;\n  color: black;\n}\n.wi-toast-content-success {\n  background-color: #93c47d;\n  color: black;\n}\n.effectivity-toast-content-success {\n  margin-top: 90px;\n  background-color: #93c47d;\n  color: black;\n}\n.effectivity-toast-content-error {\n  margin-top: 90px;\n  background-color: red;\n  color: black;\n}\n.absolute-right {\n  position: absolute !important;\n  right: 0;\n}\n.appTabs-border {\n  border-bottom: solid 1px rgba(0, 0, 0, 0.12);\n}\n.link {\n  cursor: pointer;\n  text-decoration: underline !important;\n  color: blue !important;\n}\n.data-table-container {\n  /* Add this class to the container */\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  /* Allow container to grow */\n  overflow: auto;\n  /* Allow scrolling if content overflows */\n  width: 100%;\n}\n.data-table-container .data-table {\n  flex-grow: 1;\n  /* Allow DataTable to grow */\n}\n.data-table-container .pagination-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 50px;\n  /* Ensure pagination is visible */\n  padding: 1rem;\n  overflow: auto;\n}\n.data-table-container .pagination-container .MuiPagination-root {\n  width: 100%;\n}\n.manipulation-dialog {\n  width: 100%;\n  min-height: 50%;\n  height: 70%;\n  max-height: 70%;\n  max-width: 100%;\n  margin-top: 10rem;\n  z-index: 99 !important;\n}\n.manipulation-dialog .formActionButtons {\n  text-align: right;\n}\n.tabsAndActionPanel {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.searchIconForColumn {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.h-3-5 {\n  height: 3.5%;\n}\n.headerLogoButton {\n  background: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n.pdmHistoryDialogStyle .paper {\n  width: 85% !important;\n  height: 110vh !important;\n  max-width: 100% !important;\n}\n.pdmHistoryDialogStyle .title {\n  display: flex;\n  /* keeps first span at start in normal flow */\n  align-items: center;\n  /* vertical centering if there's height */\n  justify-content: start;\n  gap: 4px;\n  width: 100%;\n  position: relative;\n}\n.pdmHistoryDialogStyle .start {\n  /* stays at the start in normal flow */\n  width: max-content;\n  min-width: max-content;\n  text-align: start;\n}\n.pdmHistoryDialogStyle .center {\n  width: max-content;\n  text-align: start;\n  display: flex;\n  justify-content: start;\n  text-overflow: clip;\n}\n.pdmHistoryDialogStyle .close {\n  align-items: center;\n  justify-content: center;\n  margin-left: auto;\n  height: 100%;\n  width: max-content;\n  min-width: max-content;\n  color: white;\n}\n.pdmHistoryDialogStyle .dialogContent {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 20px !important;\n}\n.pdmHistoryDialogStyle .dialogContent .MuiDataGrid-root {\n  min-height: 90% !important;\n}\n.pdmHistoryDialogStyle .dialogContent .manage-tab-pagination {\n  margin-top: 0 !important;\n  justify-content: center;\n  align-items: center;\n}\n.historyFilterPanel {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  width: max-content !important;\n}\n.historyFilterPanel .historyFilterContent {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  flex-wrap: wrap;\n  flex-direction: row;\n  width: max-content !important;\n}\n.historyFilterPanel .historyFilterContent .historyFilterRow {\n  display: flex;\n  gap: 16px;\n  flex-direction: row;\n  align-items: center;\n  width: max-content !important;\n}\n.historyFilterPanel .historyFilterContent .historyFilterRow .historyFilterFormControl {\n  min-width: 145px;\n}\n.color-red {\n  color: red !important;\n}\n.history-button path {\n  font-size: 18px !important;\n}\n.history-button span {\n  font-size: 12px !important;\n}\n.delete-button {\n  text-transform: capitalize !important;\n  color: red;\n}\n.autocomplete-value-mismatch .MuiOutlinedInput-notchedOutline {\n  border-color: red !important;\n}\n.autocomplete-value-mismatch .MuiOutlinedInput-input {\n  color: red !important;\n  -webkit-text-fill-color: red !important;\n}\n.autocomplete-value-mismatch .Mui-disabled .MuiOutlinedInput-notchedOutline {\n  border-color: red !important;\n}\n.autocomplete-value-mismatch .Mui-disabled .MuiOutlinedInput-input {\n  -webkit-text-fill-color: red !important;\n}\n.autocomplete-value-mismatch .MuiInputLabel-root.Mui-disabled {\n  color: red !important;\n}\n/*# sourceMappingURL=index.css.map */",".customToolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: min-content !important;\n}\n\n.columnsPanelTrigger {\n  min-height: min-content !important;\n  min-width: min-content !important;\n}\n\n.filterPanelTrigger {\n  min-height: min-content !important;\n  min-width: min-content !important;\n}\n\n@philips-blue: #1474a4;\n\n.category {\n  height: 80vh;\n  display: flex;\n  flex-direction: column;\n  padding: 2px;\n  overflow-y: auto;\n\n  .multi-numeric-icon {\n    color: #ffa300;\n  }\n\n  .header-section {\n    margin-left: 7px;\n    width: 99%;\n    box-sizing: border-box;\n    margin-bottom: 2px;\n\n    .section-view {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n\n      .edit-view {\n        button {\n          text-transform: capitalize;\n        }\n      }\n    }\n\n    .category-header-section {\n      display: flex;\n      flex-direction: row;\n      overflow: hidden;\n      width: 100%;\n      background: rgb(242, 244, 247);\n      border-radius: 1px 1px 0px 0px;\n      border: 1px solid rgb(221, 225, 233);\n      height: 35px;\n      max-height: 35px;\n      font-size: 12px !important;\n      align-items: center;\n\n      .breacrum-header-section {\n        width: 50%;\n        display: flex;\n        align-items: center;\n        .css-1v5z4dq-MuiPaper-root-MuiCard-root {\n          border: 0px;\n        }\n        button {\n          padding-top: 0px;\n          padding-bottom: 0px;\n          width: 100px;\n          margin-right: 5px;\n          margin-left: 0px;\n          height: 33px;\n          border-radius: 2px;\n          text-transform: capitalize;\n        }\n\n        .MuiPaper-root.MuiCard-root {\n          border: 0px;\n        }\n\n        nav {\n          white-space: nowrap;\n        }\n      }\n    }\n  }\n\n  .categories-container {\n    display: flex;\n    gap: 20px;\n    margin-bottom: 20px;\n    margin-left: 7px;\n    width: 99%;\n    flex: 1; // Make it take available space\n    min-height: 369px; // Minimum height\n\n    .categories-panel {\n      width: 560px;\n      display: flex;\n      flex-direction: column;\n\n      h3 {\n        margin-bottom: 8px;\n      }\n\n      .categories-list {\n        border: 1px solid #ccc;\n        border-radius: 4px;\n        overflow-y: auto; // Add vertical scroll\n        overflow-x: hidden;\n        flex: 1; // Take available height\n        max-height: calc(70vh - 150px); // Calculate maximum height\n      }\n    }\n\n    .droppable-zones {\n      display: flex;\n      gap: 20px;\n      flex: 1;\n\n      // Make each droppable zone take equal width\n      > div {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n      }\n    }\n  }\n\n  .breadcrumb-card-section {\n    nav {\n      display: flex;\n      align-items: center;\n      width: 100%;\n\n      a {\n        display: flex;\n        align-items: center;\n        text-decoration: none;\n        transition: color 0.2s ease;\n        font-size: 14px;\n        padding: 4px 6px;\n        border-radius: 4px;\n        background-color: #f2f4f7;\n\n        &.active {\n          color: black;\n          font-weight: 500;\n        }\n\n        &.not-active {\n          color: #666;\n\n          &:hover {\n            color: #333;\n            background-color: rgba(0, 0, 0, 0.04);\n          }\n        }\n      }\n\n      .MuiSvgIcon-root {\n        color: #999;\n        margin: 0 8px;\n      }\n    }\n  }\n\n  .category-content {\n    display: flex;\n    flex: 1;\n    height: calc(100% - 100px);\n    position: relative;\n  }\n\n  .left-pane,\n  .middle-pane,\n  .right-pane {\n    position: relative;\n  }\n\n  .left-pane {\n    --pane-width: 30%;\n    width: var(--pane-width);\n    min-width: 200px;\n    height: 100%;\n    border: 1px solid #eee;\n    border-radius: 4px;\n    margin-left: 8px;\n  }\n\n  .middle-pane {\n    --pane-width: 35%;\n    width: var(--pane-width);\n    min-width: 200px;\n    height: 96%;\n  }\n\n  .right-pane {\n    --pane-width: 35%;\n    width: var(--pane-width);\n    min-width: 200px;\n    height: 96%;\n  }\n\n  .resize-hor {\n    resize: horizontal;\n  }\n\n  .disabled-view {\n    opacity: 0.6;\n    pointer-events: none;\n  }\n\n  .assigned-section-header,\n  .unassingned-section-header {\n    border-bottom: 2px solid #eee;\n    padding-left: 4%;\n    font-weight: bold;\n  }\n}\n\n// Sortable Category Styles\n.category-item {\n  position: relative;\n  &.over:not(.invalid) {\n    // Only show border, no background fill\n    border: 2px solid #1474a4;\n  }\n\n  &.invalid {\n    // Only show red border, no background\n    border: 2px solid #ef4444;\n    // Ensure no other border styles interfere\n    outline: none;\n  }\n\n  &.hover:not(.invalid):not(.over) {\n    > div:first-child {\n      outline: 2px dashed #1474a4;\n      // No background fill\n    }\n  }\n  .category-row {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .category-content {\n    width: 100%;\n    position: relative;\n    z-index: 2;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    &.selected {\n      // Only highlight the text, not the whole box\n      background: transparent;\n\n      // The text and icons will be highlighted\n      .feature-name,\n      .action-button {\n        color: #1474a4;\n        font-weight: 500;\n      }\n\n      // Feature icon (folder icon) should turn blue when selected\n      .drag-handle .feature-icon .category-icon {\n        color: #1474a4 !important;\n      }\n\n      // Override multi-numeric icon color when selected\n      .drag-handle .feature-icon .category-icon.multi-numeric-icon {\n        color: #ffa300 !important;\n      }\n    }\n\n    // Highlight subcategories when their parent is selected\n    &.parent-selected {\n      .feature-name {\n        color: #1474a4;\n        font-weight: 500;\n      }\n\n      // Feature icon (folder icon) should turn blue when parent is selected\n      .drag-handle .feature-icon .category-icon {\n        color: #1474a4 !important;\n      }\n\n      .drag-handle .feature-icon .category-icon.multi-numeric-icon {\n        color: #ffa300 !important;\n      }\n    }\n  }\n\n  .category-title {\n    display: flex;\n    align-items: center;\n    flex: 1;\n  }\n  .drag-handle {\n    display: flex;\n    align-items: center;\n    flex: 1;\n  }\n  .feature-name {\n    margin-left: 6px;\n  }\n  .category-actions-wrapper {\n    display: flex;\n    align-items: center;\n    margin-left: 8px;\n  }\n  .subcategories {\n    margin-left: 20px;\n  }\n}\n\n// Droppable Zone Styles\n.droppable-zone {\n  flex: 1;\n  min-width: 300px;\n  display: flex;\n  flex-direction: column;\n  height: 98%;\n\n  h3 {\n    margin-bottom: 8px;\n\n    &.highlighted {\n      color: #1474a4;\n    }\n  }\n\n  .drop-area {\n    padding: 15px;\n    background: #fff;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    overflow-y: auto;\n    z-index: 1;\n\n    .items-container {\n      flex: 1;\n      overflow-y: auto;\n    }\n\n    &.over:not(.invalid),\n    &[data-highlight='true']:not([data-invalid='true']) {\n      border: 2px solid #1474a4 !important;\n      border-style: solid !important;\n      background: transparent;\n      z-index: 2;\n      box-shadow: 0 0 0 1px rgba(20, 116, 164, 0.3);\n    }\n\n    &.invalid,\n    &[data-invalid='true'] {\n      border: 2px solid #ef4444 !important;\n      border-style: solid !important;\n      background: transparent;\n      z-index: 3;\n      box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.3);\n    }\n\n    .empty-message {\n      color: #666;\n      font-style: italic;\n    }\n  }\n}\n\n// Draggable/Sortable Item Styles\n.draggable-sortable-item {\n  &.dragging {\n    cursor: grabbing;\n    opacity: 0.4; // Lower opacity for the original item\n    background-color: #f0f6ff !important;\n    border: 1px dashed #ccc;\n    box-shadow: none;\n    z-index: 1000 !important; // Ensure it's on top\n    pointer-events: none; // Allow drops to pass through\n  }\n  &.sortable {\n    border-radius: 4px;\n    cursor: grab;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n\n    .item-content {\n      flex: 1;\n      display: flex;\n      align-items: center;\n      overflow: hidden;\n      font-weight: 400;\n      font-size: 1rem;\n      line-height: 1.5;\n      letter-spacing: 0.00938em;\n\n      .item-description {\n        margin-right: 4px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .item-code {\n        flex-shrink: 0;\n        white-space: nowrap;\n        color: #666;\n      }\n    }\n\n    .item-actions {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n\n      .drag-handle {\n        color: #666;\n        font-size: 14px;\n      }\n    }\n  }\n\n  &.draggable {\n    border-radius: 4px;\n    cursor: grab;\n    display: flex;\n    align-items: center;\n    .item-content {\n      margin-left: 8px;\n      flex: 1;\n      display: flex;\n      align-items: center;\n      overflow: hidden;\n      font-weight: 400;\n      font-size: 1rem;\n      line-height: 1.5;\n      letter-spacing: 0.00938em;\n\n      .item-description {\n        margin-right: 4px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .item-code {\n        flex-shrink: 0;\n        white-space: nowrap;\n        color: #666;\n      }\n    }\n  }\n\n  &.disabled {\n    opacity: 0.6;\n    cursor: default;\n    pointer-events: none;\n    color: #888;\n\n    &.sortable {\n      background: #f7f9ff;\n    }\n\n    &.draggable {\n      background: #f5f5f5;\n    }\n  }\n}\n\n// Add Category Dialog Styles\n.common-dialog-style {\n  .MuiPaper-root {\n    .MuiDialogTitle-root {\n      background: #1474a4;\n      color: #fff;\n      padding: 7px;\n      padding-left: 23px;\n      cursor: move;\n    }\n\n    .MuiBox-root {\n      width: 100%;\n    }\n  }\n}\n.add-category-dialog {\n  .MuiPaper-root {\n    width: 80%;\n  }\n}\n// Custom drag preview\n.drag-preview {\n  padding: 2px 2px;\n  border-radius: 4px;\n  background: #1474a4;\n  color: rgb(255, 255, 255);\n  font-weight: 500;\n  font-size: 12px;\n  pointer-events: none;\n  max-width: 300px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n\n  .item-code {\n    opacity: 0.8;\n    font-size: 12px;\n  }\n}\n\n// Ensure drag overlay is always on top\n[data-dnd-overlay] {\n  z-index: 9999 !important;\n}\n\n.drag-overlay-content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n\n  .item-name {\n    font-weight: 500;\n  }\n\n  .item-code {\n    color: #666;\n  }\n}\n\n.auto-complete-searchbar {\n  margin-top: 16px;\n  display: flex;\n}\n\n.auto-complete-search-input {\n  flex-basis: 90%;\n\n  .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {\n    border-radius: 4px 0px 0px 4px !important;\n  }\n}\n\n.auto-complete-search-button {\n  background: white;\n  border-radius: 0px 4px 4px 0px !important;\n  border: solid 2px #e2e2e2 !important;\n  border-left: none !important;\n}\n\n.auto-complete-search-icon {\n  font-size: 25px !important;\n  color: @philips-blue !important;\n}\n\n.css-xnywni-MuiFormLabel-root-MuiInputLabel-root {\n  top: 20px !important;\n  position: relative !important;\n}\n\n.css-196bwzp-MuiPaper-root-MuiCard-root {\n  background-color: #f2f4f7 !important;\n}\n\n.css-1umw9bq-MuiSvgIcon-root {\n  width: 16px !important;\n  height: 0.9em !important;\n}\n\n// Large header icon style for header action icons\n.header-large-icon {\n  font-size: 1.7rem !important;\n  line-height: 1;\n}\n\n.icon-with-label {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-right: 24px;\n}\n\n.edit-view {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n}\n\n.icon-helper-text {\n  font-size: 0.95rem;\n  color: #1474a4;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n}\n\n.css-nykz7-MuiTreeItem-content {\n  padding: 4px 8px 0px 0px !important;\n  gap: 0px !important;\n}\n\n.css-nykz7-MuiTreeItem-content.Mui-selected {\n  background-color: revert !important;\n}\n\n.category-wrapper {\n  padding-left: 0;\n}\n\n.category-wrapper[data-section-depth] {\n  padding-left: calc(var(--category-depth, 0) * 20px);\n}\n\n.css-fojsl4-MuiTreeItem-content {\n  gap: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
